(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__esPdpAccordion) return;
    window.__esPdpAccordion = true;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function openPanel(trigger, panel) {
      trigger.setAttribute('aria-expanded', 'true');
      if (reduce) {
        panel.style.height = 'auto';
        return;
      }
      var target = panel.scrollHeight;
      panel.style.height = '0px';
      void panel.offsetHeight;
      panel.style.height = target + 'px';
      var onEnd = function () {
        panel.removeEventListener('transitionend', onEnd);
        panel.style.height = 'auto';
      };
      panel.addEventListener('transitionend', onEnd);
    }

    function closePanel(trigger, panel) {
      trigger.setAttribute('aria-expanded', 'false');
      if (reduce) {
        panel.style.height = '0px';
        return;
      }
      panel.style.height = panel.scrollHeight + 'px';
      void panel.offsetHeight;
      panel.style.height = '0px';
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest ? e.target.closest('[data-accordion-trigger]') : null;
      if (!trigger) return;
      var acc = trigger.closest('.pdp-accordion');
      var panel = acc ? acc.querySelector('[data-accordion-panel]') : null;
      if (!panel) return;
      if (trigger.getAttribute('aria-expanded') === 'true') {
        closePanel(trigger, panel);
        return;
      }
      /* Exclusive group: opening one accordion closes its open siblings.
         Opt-in via data-accordion-exclusive on a wrapping element. */
      var group = trigger.closest('[data-accordion-exclusive]');
      if (group) {
        group.querySelectorAll('[data-accordion-trigger][aria-expanded="true"]').forEach(function (other) {
          var otherAcc = other.closest('.pdp-accordion');
          var otherPanel = otherAcc ? otherAcc.querySelector('[data-accordion-panel]') : null;
          if (otherPanel) closePanel(other, otherPanel);
        });
      }
      openPanel(trigger, panel);
    });

    /* Theme editor: selecting an accordion block expands it. */
    document.addEventListener('shopify:block:select', function (e) {
      var acc = e.target.closest ? e.target.closest('.pdp-accordion') : null;
      if (!acc) return;
      var trigger = acc.querySelector('[data-accordion-trigger]');
      var panel = acc.querySelector('[data-accordion-panel]');
      if (trigger && panel && trigger.getAttribute('aria-expanded') !== 'true') {
        openPanel(trigger, panel);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["header-menu-item"] && !Shopify.designMode) return;
  try {
    (function () {
    // Desktop hover behaviour, shared across every mega-menu on the page.
    //
    // OPEN_DELAY: a short dwell is required before the FIRST panel opens, so
    // brushing the cursor past a trigger (or near it) does not open the menu -
    // the user has to mean it.
    //
    // Anti-flash: once any panel is open the menu "system" stays open through a
    // brief close grace (CLOSE_DELAY). Moving to another trigger within that
    // window swaps panels instantly and WITHOUT the fade (the .is-instant
    // class), so quickly running the cursor between menus no longer flashes.
    var OPEN_DELAY = 500; // ms of hover intent before the first panel opens (matches the legacy theme)
    var CLOSE_DELAY = 450; // ms grace before the whole system closes on leave (matches the legacy theme)
    var systemOpen = false; // a panel is currently open (or within close grace)
    var systemCloseTimer = null;

    function clearSystemCloseTimer() {
      if (systemCloseTimer) {
        clearTimeout(systemCloseTimer);
        systemCloseTimer = null;
      }
    }

    class MegaMenu extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-mega-trigger]');
        this.panel = this.querySelector('[data-mega-panel]');
        if (!this.trigger || !this.panel) return;

        this.mql = window.matchMedia('(min-width: 1104px)');
        this.locked = false; // pinned open by a click (ignores hover-close)
        this.pointerInside = false; // pointer currently over this menu
        this.openTimer = null; // pending hover-intent open
        this.onEnter = this.onEnter.bind(this);
        this.onLeave = this.onLeave.bind(this);
        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);

        this.addEventListener('mouseenter', this.onEnter);
        this.addEventListener('mouseleave', this.onLeave);
        this.trigger.addEventListener('click', this.onTriggerClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('click', this.onDocumentClick);
      }

      disconnectedCallback() {
        this.clearOpenTimer();
        this.removeEventListener('mouseenter', this.onEnter);
        this.removeEventListener('mouseleave', this.onLeave);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('click', this.onDocumentClick);
      }

      get isDesktop() {
        return this.mql.matches;
      }

      open(instant) {
        if (!this.isDesktop) return;
        clearSystemCloseTimer();
        var others = document.querySelectorAll('mega-menu[open]');
        for (var i = 0; i < others.length; i++) {
          // On an instant swap, close the outgoing panel instantly too so it
          // neither fades nor slides upward behind the incoming one.
          if (others[i] !== this) others[i].close(instant);
        }
        // Instant swap (a panel was already open): apply the open state with
        // transitions disabled and force a style flush so it is COMMITTED as
        // shown, then re-enable transitions so the panel still fades out on
        // close. Without the flush the browser coalesces both changes and fades
        // the panel IN, which crossfades with the outgoing panel and briefly
        // reveals the page behind. A rAF here is too late - it runs before the
        // only paint, so the instant state is never rendered.
        if (instant) {
          this.classList.add('is-instant');
          this.setAttribute('open', '');
          void this.panel.offsetWidth; // force reflow to commit the shown state
          this.classList.remove('is-instant');
        } else {
          this.setAttribute('open', '');
        }
        this.trigger.setAttribute('aria-expanded', 'true');
        systemOpen = true;
      }

      close(instant) {
        this.clearOpenTimer();
        this.locked = false;
        if (instant) {
          // Hide with transitions off so the outgoing panel neither fades nor
          // slides up during a swap; commit the hidden state, then restore
          // transitions for its next (normal) close.
          this.classList.add('is-instant');
          this.removeAttribute('open');
          void this.panel.offsetWidth; // commit the hidden state instantly
          this.classList.remove('is-instant');
        } else {
          this.classList.remove('is-instant');
          this.removeAttribute('open');
        }
        this.trigger.setAttribute('aria-expanded', 'false');
      }

      clearOpenTimer() {
        if (this.openTimer) {
          clearTimeout(this.openTimer);
          this.openTimer = null;
        }
      }

      onEnter() {
        if (!this.isDesktop) return;
        this.pointerInside = true;
        // Moving between triggers: cancel the pending system close so this
        // counts as a switch, not a fresh open.
        clearSystemCloseTimer();
        if (systemOpen) {
          // A panel is already open - swap to this one instantly, no dwell.
          this.open(true);
          return;
        }
        // First open: require the dwell, and only open if the pointer is still
        // over this menu when the timer fires.
        this.clearOpenTimer();
        var self = this;
        this.openTimer = setTimeout(function () {
          self.openTimer = null;
          if (self.pointerInside) self.open(false);
        }, OPEN_DELAY);
      }

      onLeave() {
        this.pointerInside = false;
        // Grazed away before the dwell elapsed: cancel the pending open.
        this.clearOpenTimer();
        // Pinned-open menus ignore hover-close; they close on a second click,
        // an outside click, or Escape.
        if (this.locked) return;
        if (!this.hasAttribute('open')) return;
        // Close the whole system after a short grace so crossing the gap into
        // the panel, or moving to the next trigger, does not close it.
        var self = this;
        clearSystemCloseTimer();
        systemCloseTimer = setTimeout(function () {
          systemCloseTimer = null;
          systemOpen = false;
          self.close();
        }, CLOSE_DELAY);
      }

      onTriggerClick(event) {
        if (!this.isDesktop) return;
        // A trigger with its own destination navigates on click (hover still
        // opens the panel). Only link-less triggers toggle the panel.
        if (this.trigger.hasAttribute('data-mega-linked')) return;
        event.preventDefault();
        this.clearOpenTimer();
        // Click toggles: pin open if not already pinned (hover may have
        // previewed it open), otherwise close.
        if (this.locked) {
          systemOpen = false;
          this.close();
        } else {
          this.locked = true;
          this.open(false);
        }
      }

      onDocumentClick(event) {
        if (!this.hasAttribute('open')) return;
        if (this.contains(event.target)) return;
        systemOpen = false;
        this.close();
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.hasAttribute('open')) {
          systemOpen = false;
          this.close();
          this.trigger.focus();
        } else if (event.key === 'ArrowDown' && event.target === this.trigger && this.isDesktop) {
          event.preventDefault();
          this.open(false);
          var first = this.panel.querySelector('a');
          if (first) first.focus();
        }
      }

      onFocusOut(event) {
        if (!this.contains(event.relatedTarget)) {
          systemOpen = false;
          this.close();
        }
      }
    }

    if (!customElements.get('mega-menu')) {
      customElements.define('mega-menu', MegaMenu);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["manual-variants"] && !Shopify.designMode) return;
  try {
    // Echo the selected chip's label next to the row label ("Value: $50"). A
  // parent theme block cannot read its children's settings, so the value is
  // read back out of the DOM. Progressive enhancement: without this the row
  // still reads correctly as just the label.
  class ManualVariants extends HTMLElement {
    connectedCallback() {
      var target = this.querySelector('[data-mv-selected]');
      var current = this.querySelector('[data-mv-current]');
      if (!target || !current) return;
      var label = current.getAttribute('data-mv-label');
      if (!label) return;
      target.textContent = ': ' + label;
      target.hidden = false;
    }
  }
  if (!customElements.get('manual-variants')) {
    customElements.define('manual-variants', ManualVariants);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-details"] && !Shopify.designMode) return;
  try {
    (function () {
    /* The Package SKU follows the selected variant. product-variants announces a
       change with the variant id only, so the SKU is looked up from the ids and
       SKUs the row carries. Queried from the document on every change because the
       Drawer Toggles container moves the panel into its dialog, and a bundle's
       fill may have rebuilt the panel around the row since it rendered. */
    document.addEventListener('variant:change', function (event) {
      var id = event.detail && event.detail.variantId;
      if (!id) return;
      document.querySelectorAll('[data-package-sku]').forEach(function (list) {
        var ids, skus;
        try {
          ids = JSON.parse(list.getAttribute('data-variant-ids') || '[]');
          skus = JSON.parse(list.getAttribute('data-variant-skus') || '[]');
        } catch (e) { return; }
        var i = ids.map(String).indexOf(String(id));
        if (i === -1) return;
        var sku = skus[i] || '';
        var value = list.querySelector('[data-package-sku-value]');
        if (value) value.textContent = sku;
        list.hidden = !sku;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-drawers"] && !Shopify.designMode) return;
  try {
    (function () {
    class ProductDrawers extends HTMLElement {
      connectedCallback() {
        if (this.__init) return;
        this.__init = true;
        this.dialog = this.querySelector('[data-pdp-drawer]');
        this.tablist = this.querySelector('[data-pdp-tablist]');
        this.panelsHost = this.querySelector('[data-pdp-panels]');
        if (!this.dialog || !this.tablist || !this.panelsHost) return;
        this.tabs = [];
        this.lastTrigger = null;
        this.build();
        if (this.hasAttribute('data-mix-match')) {
          this.setupMixMatch();
        } else {
          this.hydrateBundle();
        }
        this.bindDialog();
        this.setupEditor();
      }

      /* Theme editor: reveal the drawer (open it on the relevant tab) while the
         merchant is editing the Drawer Toggles block or one of its child blocks.
         Mirrors the overlay sections' editor-preview behaviour. */
      setupEditor() {
        if (!window.Shopify || !window.Shopify.designMode) return;
        var self = this;
        this.onEditorSelect = function (e) {
          var target = e.target;
          if (!target || (target !== self && !self.contains(target))) return;
          clearTimeout(self.editorCloseTimer);
          var item = target.closest ? target.closest('[data-pdp-item]') : null;
          if (item && self.contains(item)) {
            var trig = item.querySelector('[data-pdp-trigger]');
            var panelId = trig ? trig.getAttribute('data-pdp-target') : null;
            if (panelId) { self.open(panelId, null); return; }
          }
          if (self.tabs[0]) self.open(self.tabs[0].id, null);
        };
        this.onEditorDeselect = function (e) {
          var target = e.target;
          if (!target || (target !== self && !self.contains(target))) return;
          /* Debounce so switching from one drawer block to another (deselect
             then select) doesn't flicker the drawer shut and open again. */
          clearTimeout(self.editorCloseTimer);
          self.editorCloseTimer = setTimeout(function () { self.close(); }, 50);
        };
        document.addEventListener('shopify:block:select', this.onEditorSelect);
        document.addEventListener('shopify:block:deselect', this.onEditorDeselect);
      }

      /* ---- Native bundle drawers -------------------------------------------
         A bundle has no PIM record, so Product Details, Specs & Dimensions,
         Technical Details, Product Care and Assembly are all empty on it and
         render as hidden shells. Its components DO carry that data, and the
         design stacks them inside the bundle's own drawers under a heading
         each. Which products a bundle contains is only answerable by the
         Storefront API; their drawer markup then comes back from the theme's own
         blocks, rendered against each component (sections/bundle-component-
         drawers.liquid), so the two can never drift.

         A shell nothing came back for is removed rather than left empty. */
      hydrateBundle() {
        var self = this;
        var shells = this.querySelectorAll('[data-bundle-fill]');
        if (!this.hasAttribute('data-bundle') || !shells.length) return;
        /* A preset bundle names its members in a metafield, so the handles are
           already on the element - no Storefront API round trip. Everything after
           discovery is identical to a native bundle. */
        var preset = (this.getAttribute('data-preset-handles') || '').trim();
        if (preset) {
          var presetHandles = preset.split(',').map(function (h) { return h.trim(); })
            .filter(function (h, i, all) { return h && all.indexOf(h) === i; });
          if (!presetHandles.length) { self.dropEmptyShells(); return; }
          self.fillFromHandles(presetHandles);
          return;
        }

        var token = (this.getAttribute('data-sfapi-token') || '').trim();
        var handle = this.getAttribute('data-product-handle') || '';
        if (!token || !handle) { self.dropEmptyShells(); return; }

        var query = 'query BundleComponents($handle: String!) {' +
          ' product(handle: $handle) { variants(first: 1) { nodes {' +
          ' components(first: 30) { nodes { productVariant { product { handle } } } }' +
          ' } } } }';
        fetch(location.origin + '/api/2026-04/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
          body: JSON.stringify({ query: query, variables: { handle: handle } })
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (res) {
            var variant = res && res.data && res.data.product && res.data.product.variants.nodes[0];
            var nodes = (variant && variant.components.nodes) || [];
            var handles = nodes.map(function (n) { return n.productVariant.product.handle; });
            handles = handles.filter(function (h, i) { return h && handles.indexOf(h) === i; });
            if (!handles.length) { self.dropEmptyShells(); return; }
            return self.fillFromHandles(handles);
          })
          .then(function () { self.dropEmptyShells(); self.build(); })
          .catch(function () { self.dropEmptyShells(); self.markPositions(); });
      }

      /* ---- Mix & Match drawers ---------------------------------------------
         The same per-component fill as a bundle, with two differences. The
         components are whatever the buy box has SELECTED - so there is no
         discovery hop: the pair is read straight from its checked inputs, the
         way the store locator does - and they change. Every swap of a shade
         or base re-fills the drawers, so the drawers always describe the pair
         on screen (#19722058).

         Because a fill can be undone, nothing is thrown away: a shell the pair
         has nothing for is hidden rather than removed, its tab with it, and a
         fallback drawer's own content is kept so it comes back when a later
         pair supplies nothing (see resetFills). Each component's markup is
         fetched once and cached, so swapping back to a shade already seen
         costs no request. */
      setupMixMatch() {
        var self = this;
        this.mmCache = {};
        this.mmSeq = 0;
        this.mmLastKey = null;
        var timer = null;
        /* Debounced like the store locator: dragging along the carousel fires a
           change per option, and each fill is one section render per component. */
        document.addEventListener('mix-match:change', function (e) {
          var handles = e.detail && e.detail.handles;
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            timer = null;
            self.refillMixMatch(handles);
          }, 250);
        });
        /* The buy box syncs (and announces) the moment it upgrades. If it is
           already defined it has done so, and the event is gone - so the current
           pair is read from the DOM instead. If not, its first announcement is
           still to come and is what the listener above is for; reading the
           default pair now would only be superseded by the URL's. */
        if (window.customElements.get('mix-match-buybox')) {
          this.refillMixMatch(null);
        }
      }

      mmSelectedHandles() {
        var inputs = document.querySelectorAll('.mix-match__option-input:checked');
        var out = [];
        for (var i = 0; i < inputs.length; i++) {
          var h = inputs[i].value;
          if (h && out.indexOf(h) === -1) out.push(h);
        }
        return out;
      }

      fetchComponentDrawers(handle) {
        if (this.mmCache[handle]) return this.mmCache[handle];
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.mmCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=bundle-component-drawers')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
        return this.mmCache[handle];
      }

      /* Re-fills every drawer for the given pair (component order, as the buy
         box lists them). Fetched in parallel - the order the fills are APPLIED
         in is what sets the heading order, and that is fixed once every
         response is in. A newer selection arriving mid-flight wins: the older
         one is discarded rather than painted over the top. */
      refillMixMatch(handles) {
        var self = this;
        if (!handles || !handles.length) handles = this.mmSelectedHandles();
        var key = handles.join('|');
        if (key === this.mmLastKey) return;
        this.mmLastKey = key;
        var seq = ++this.mmSeq;
        if (!handles.length) {
          this.resetFills();
          this.settleMixMatch();
          return;
        }
        Promise.all(handles.map(function (h) { return self.fetchComponentDrawers(h); }))
          .then(function (htmls) {
            if (seq !== self.mmSeq) return;
            self.resetFills();
            htmls.forEach(function (html) { self.fillFrom(html); });
            self.settleMixMatch();
          })
          .catch(function () {
            if (seq !== self.mmSeq) return;
            self.settleMixMatch();
          });
      }

      /* Puts every fillable drawer back to how it rendered: the component
         content goes, a fallback drawer gets its own content back, and a bare
         shell is hidden again. What fillFrom does, undone. */
      resetFills() {
        var self = this;
        this.querySelectorAll('[data-bundle-fill]').forEach(function (shell) {
          var panelBody = self.shellBody(shell);
          if (panelBody) {
            var target = panelBody.querySelector('[data-bundle-target]');
            if (target) target.parentNode.removeChild(target);
            if (shell.hasAttribute('data-bundle-fallback') && shell.__ownSaved) {
              panelBody.innerHTML = shell.__ownHTML;
            }
          }
          shell.removeAttribute('data-bundle-filled');
          if (!shell.hasAttribute('data-bundle-fallback')) shell.hidden = true;
        });
      }

      /* After a Mix & Match fill: build tabs for anything newly filled, then
         hide the tab of any drawer this pair has nothing for (and move off it
         if it was the one showing). build() handles the first appearance of a
         drawer, but never a disappearance - shells were only ever removed for
         good before this. */
      settleMixMatch() {
        var self = this;
        this.build();
        var activeHidden = false;
        this.tabs.forEach(function (t) {
          var item = self.querySelector('[data-pdp-panel-id="' + t.id + '"]');
          var show = !!item && !item.hidden
            && !(item.hasAttribute('data-bundle-fill') && !item.hasAttribute('data-bundle-filled')
              && !item.hasAttribute('data-bundle-fallback'));
          t.tab.hidden = !show;
          if (!show && t.tab.classList.contains('is-active')) activeHidden = true;
        });
        if (activeHidden) {
          var first = null;
          for (var i = 0; i < this.tabs.length; i++) {
            if (!this.tabs[i].tab.hidden) { first = this.tabs[i]; break; }
          }
          if (first) this.activate(first.id);
        }
      }

      /* The panel body a shell's content lives in. Usually still inside the
         shell, but build() MOVES a panel out to the tab host once it shows, so
         the id build() recorded is followed when it has gone (#19566181). */
      shellBody(shell) {
        var panelBody = shell.querySelector('.pdp-tabs__content');
        if (!panelBody) {
          var movedId = shell.getAttribute('data-pdp-panel-id');
          var movedPanel = movedId ? document.getElementById(movedId) : null;
          if (movedPanel) panelBody = movedPanel.querySelector('.pdp-tabs__content');
        }
        return panelBody;
      }

      /* Fetches each component's drawers in turn and fills the shells from them.
         Sequential rather than parallel: the order of the headings inside each
         drawer has to follow the component order. */
      fillFromHandles(handles) {
        var self = this;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return handles.reduce(function (chain, h) {
          return chain.then(function () {
            return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=bundle-component-drawers')
              .then(function (r) { return r.ok ? r.text() : ''; })
              .then(function (html) { self.fillFrom(html); })
              .catch(function () {});
          });
        }, Promise.resolve())
          .then(function () { self.dropEmptyShells(); self.build(); })
          .catch(function () { self.dropEmptyShells(); self.markPositions(); });
      }

      /* Takes one component's rendered drawers and appends each to the matching
         shell, under a heading naming that component. */
      fillFrom(html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var source = tmp.querySelector('[data-bundle-drawers]');
        if (!source) return;
        var label = source.getAttribute('data-label') || '';
        var self = this;
        source.querySelectorAll('[data-bundle-drawer]').forEach(function (group) {
          var type = group.getAttribute('data-bundle-drawer');
          var body = group.querySelector('[data-pdp-panel] .pdp-tabs__content');
          if (!body || !body.textContent.trim()) return;
          var shell = self.querySelector('[data-bundle-fill="' + type + '"]');
          if (!shell) return;

          /* The body is usually still inside the shell, but not always: build()
             runs before this fill and MOVES a panel out to the tab host. It skips
             an empty shell (a native bundle's), so those are still intact - but a
             preset bundle's fallback shell is not skipped, because it is showing
             the parent's own content. Its panel has already gone, which is why the
             fill used to land in a detached node and never appear (#19566181).
             Follow the id build() recorded. */
          var panelBody = self.shellBody(shell);
          if (!panelBody) return;

          /* Assembly is the one drawer whose body is not all component-specific
             (#18564009). The intro and the Start live chat link are boilerplate:
             every component renders its own, so a two-piece bundle showed the
             intro twice and offered live chat twice. They are lifted out of each
             component's body and shown once, above the first component heading.
             Everything else in the panel stays per component exactly as it was.

             Which intro wins, when more than one has been enriched: the parent's
             own if it has one, otherwise the first component that does, in the
             order the handles are listed in esr.preset_bundle_product_handles.
             Components are fetched one after another in that order, so the choice
             is stable rather than a race. */
          var isAssembly = type === 'product-assembly';
          var parentIntro = null;

          var target = panelBody.querySelector('[data-bundle-target]');
          if (!target) {
            /* Components win per drawer, the parent is only the fallback: the first
               component to supply this drawer clears the parent's own content. Done
               here rather than up front because we only know a drawer HAS a
               component version once one arrives - and a drawer none of them supply
               has to keep what it had. Children are removed rather than the parent
               body being wrapped, so .pdp-tabs__content keeps its direct children
               and the --stacked spacing still applies. */
            if (shell.hasAttribute('data-bundle-fallback')) {
              /* Taken out before the wipe, not after: the parent's own intro is
                 the preferred single intro, and clearing the fallback content is
                 what would otherwise throw it away. */
              /* Remembered before it goes, not discarded: on Mix & Match a later
                 pair may have nothing for this drawer, and the parent's own
                 content then comes back (resetFills). Taken once - the first
                 fill sees the content exactly as it rendered. */
              if (!shell.__ownSaved) {
                shell.__ownHTML = panelBody.innerHTML;
                shell.__ownSaved = true;
              }
              if (isAssembly) { parentIntro = panelBody.querySelector('.product-assembly__intro'); }
              /* The parent's own content that describes the package rather than
                 a component - the Package SKU row (task 20273180) - is lifted out
                 of the wipe and put back above the component sections. */
              var keep = [].slice.call(panelBody.querySelectorAll('[data-bundle-keep]'));
              keep.forEach(function (el) { el.parentNode.removeChild(el); });
              while (panelBody.firstChild) panelBody.removeChild(panelBody.firstChild);
              keep.forEach(function (el) { panelBody.appendChild(el); });
            }
            target = document.createElement('div');
            target.setAttribute('data-bundle-target', '');
            panelBody.appendChild(target);
            if (parentIntro) { self.assemblyLead(target).appendChild(parentIntro); }
          }
          var heading = document.createElement('h3');
          heading.className = 'product-drawer__component-heading';
          heading.textContent = label;
          target.appendChild(heading);
          /* Carry the panel's own modifier classes onto the per-component wrapper.
             They are what space a drawer's parts - product-technical-details and
             product-specs-dimensions pass pdp-tabs__content--stacked, whose gap
             sits between the spec table and the "Additional information" panel.
             Without them that gap is lost, since the parts are no longer direct
             children of .pdp-tabs__content. Copied rather than named so any
             panel_class a block adds later comes along too. */
          if (isAssembly) {
            /* First of each wins and the rest are dropped, so the panel carries
               exactly one intro and one chat link however many components arrive.
               Order inside the lead is intro then link, matching the design. */
            var intro = body.querySelector('.product-assembly__intro');
            if (intro) {
              var lead = self.assemblyLead(target);
              if (lead.querySelector('.product-assembly__intro')) {
                intro.parentNode.removeChild(intro);
              } else {
                lead.insertBefore(intro, lead.firstChild);
              }
            }
            var chat = body.querySelector('.product-assembly__chat');
            if (chat) {
              var chatLead = self.assemblyLead(target);
              if (chatLead.querySelector('.product-assembly__chat')) {
                chat.parentNode.removeChild(chat);
              } else {
                chatLead.appendChild(chat);
              }
            }
          }

          var wrap = document.createElement('div');
          wrap.className = 'product-drawer__component-body';
          body.classList.forEach(function (cls) {
            if (cls !== 'pdp-tabs__content') wrap.classList.add(cls);
          });
          while (body.firstChild) { wrap.appendChild(body.firstChild); }
          target.appendChild(wrap);
          shell.setAttribute('data-bundle-filled', '');
          shell.hidden = false;
        });
      }

      /* The one-per-panel home for the assembly intro and chat link. Created on
         first use rather than up front, so a panel with neither (no intro
         enriched anywhere and live chat switched off) never gets a stray empty
         element to space around. */
      assemblyLead(target) {
        var lead = target.querySelector('[data-bundle-assembly-lead]');
        if (!lead) {
          lead = document.createElement('div');
          lead.className = 'product-drawer__assembly-lead';
          lead.setAttribute('data-bundle-assembly-lead', '');
          target.insertBefore(lead, target.firstChild);
        }
        return lead;
      }

      /* Shells the components had nothing for never become drawers.

         A preset bundle's fallback drawers are excluded: they carry the parent's own
         content, so an unfilled one is not empty and must survive. Only a true shell
         - rendered blank precisely because there was nothing to show - is removed. */
      dropEmptyShells() {
        var sel = '[data-bundle-fill]:not([data-bundle-filled]):not([data-bundle-fallback])';
        this.querySelectorAll(sel).forEach(function (shell) {
          if (shell.parentNode) shell.parentNode.removeChild(shell);
        });
      }

      build() {
        var self = this;
        if (!this.seenSingletons) this.seenSingletons = {};
        this.querySelectorAll('[data-pdp-item]').forEach(function (item) {
          var panel = item.querySelector('[data-pdp-panel]');
          var trigger = item.querySelector('[data-pdp-trigger]');
          if (!panel || !trigger || panel.__moved) return;
          /* A bundle shell has no content until its components are fetched.
             Skipped entirely until then - no panel move, no tab - so a drawer
             the components turn out to have nothing for never appears. */
          /* Skip a shell nothing has filled yet - it contributes no tab. A preset
             bundle's fallback drawer is not skipped: unfilled still means it is
             showing the parent's own content. */
          if (item.hasAttribute('data-bundle-fill') && !item.hasAttribute('data-bundle-filled')
              && !item.hasAttribute('data-bundle-fallback')) return;

          /* Single-use types (everything except the generic Drawer) render at
             most once: hide any duplicate and skip its tab/panel. The editor
             can't disable the second "Add" for nested theme blocks, so the
             cap is enforced here at render. */
          var singleton = item.getAttribute('data-pdp-singleton');
          if (singleton) {
            if (self.seenSingletons[singleton]) {
              item.hidden = true;
              return;
            }
            self.seenSingletons[singleton] = true;
          }

          panel.__moved = true;

          var panelId = panel.id;
          var label = panel.getAttribute('data-label') || '';

          /* Remember where this panel ends up. It is about to be moved out of its
             item into the tab host, and a bundle shell's fill arrives later - see
             fillFrom, which follows this id to find the body again. */
          if (panelId) { item.setAttribute('data-pdp-panel-id', panelId); }

          var tab = document.createElement('button');
          tab.type = 'button';
          tab.className = 'pdp-tabs__tab button button--text button--dark-oak button--large';
          tab.setAttribute('role', 'tab');
          tab.setAttribute('data-pdp-tab', panelId);
          tab.setAttribute('aria-controls', panelId);
          var tabLabel = document.createElement('span');
          tabLabel.className = 'button__label';
          tabLabel.textContent = label;
          tab.appendChild(tabLabel);
          tab.addEventListener('click', function () { self.activate(panelId); });
          self.tablist.appendChild(tab);

          self.panelsHost.appendChild(panel);
          self.tabs.push({ id: panelId, tab: tab, panel: panel });

          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            self.open(panelId, trigger);
          });
        });
        this.sortTabs();
        this.markPositions();
      }

      /* Tabs follow the drawer order on the page, not the order they were built
         in. build() runs twice on a bundle - once for the drawers that rendered
         server-side, then again once the component-filled shells arrive - so
         tabs created in the second pass would otherwise land after ones the
         merchant placed below them ("Returns Policy" jumping to second).
         Re-homing each tab in item order is idempotent, so it can run on every
         build. */
      sortTabs() {
        var self = this;
        var ordered = [];
        this.querySelectorAll('[data-pdp-item]').forEach(function (item) {
          var trigger = item.querySelector('[data-pdp-trigger]');
          var id = trigger ? trigger.getAttribute('data-pdp-target') : null;
          if (!id) return;
          var entry = null;
          for (var i = 0; i < self.tabs.length; i++) {
            if (self.tabs[i].id === id) { entry = self.tabs[i]; break; }
          }
          if (!entry) return;
          /* appendChild MOVES, so walking the items in order rebuilds both the
             tab bar and the panel stack in that order. */
          self.tablist.appendChild(entry.tab);
          self.panelsHost.appendChild(entry.panel);
          ordered.push(entry);
        });
        /* Anything with no item left on the page (a removed shell) keeps its
           place at the end rather than being dropped from the array. */
        this.tabs.forEach(function (t) {
          if (ordered.indexOf(t) === -1) ordered.push(t);
        });
        this.tabs = ordered;
      }

      /* Position among the drawers that actually SHOW - the basis for both the
         first-row border and the "Limit toggles to four" cut-off. Empty children
         leave a .shopify-block wrapper behind, so counting anything but the
         rendered items counts slots that show nothing.

         A separate pass rather than part of build()'s loop: build() runs again
         after a bundle's shells are filled, and skips everything it has already
         moved, so a counter kept inside it would only ever see the new arrivals.
         This recomputes from scratch every time and is safe to repeat. */
      markPositions() {
        var shown = 0;
        this.querySelectorAll('[data-pdp-item]').forEach(function (item) {
          item.removeAttribute('data-pdp-first');
          item.removeAttribute('data-pdp-over-limit');
          /* Not showing: an unfilled bundle shell, or a duplicate singleton that
             build() hid. Neither takes a slot. */
          if (item.hidden) return;
          /* Skip a shell nothing has filled yet - it contributes no tab. A preset
             bundle's fallback drawer is not skipped: unfilled still means it is
             showing the parent's own content. */
          if (item.hasAttribute('data-bundle-fill') && !item.hasAttribute('data-bundle-filled')
              && !item.hasAttribute('data-bundle-fallback')) return;
          if (shown === 0) item.setAttribute('data-pdp-first', '');
          if (shown >= 4) item.setAttribute('data-pdp-over-limit', '');
          shown++;
        });
        /* Hands the limit over from the pre-JS nth-child rule to this marking.
           Set even when nothing rendered, so an all-empty list does not sit on
           the wrapper-based rule. */
        this.setAttribute('data-pdp-counted', '');
      }

      bindDialog() {
        var self = this;
        var closeBtn = this.dialog.querySelector('[data-pdp-close]');
        if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });

        /* Backdrop / outside-panel click closes. */
        this.dialog.addEventListener('click', function (e) {
          if (e.target === self.dialog) self.close();
        });

        /* Native close (Esc, .close()): restore scroll + focus. */
        this.dialog.addEventListener('close', function () {
          document.documentElement.style.overflow = '';
          if (self.lastTrigger && typeof self.lastTrigger.focus === 'function') {
            self.lastTrigger.focus();
          }
          self.lastTrigger = null;
        });
      }

      open(panelId, trigger) {
        this.activate(panelId);
        this.lastTrigger = trigger || null;
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
        /* showModal() auto-focuses the first focusable element, which here is the
           close X, and that paints its focus ring - the stray box reported around
           close buttons on mobile (design QA 5230074). Move initial focus to the
           panel instead. The panel needs tabindex="-1" for this to do anything:
           .focus() on a non-focusable element is a silent no-op, which is exactly
           how this regressed. aria-label on the dialog still announces it, and
           keyboard users Tab on from here, so the ring appears only on genuine
           keyboard navigation. Matches snippets/drawer.liquid. */
        var panel = this.dialog.querySelector('.pdp-tabs-drawer__panel');
        if (panel && typeof panel.focus === 'function') panel.focus();
        document.documentElement.style.overflow = 'hidden';
      }

      close() {
        if (typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
        }
      }

      activate(panelId) {
        this.tabs.forEach(function (t) {
          var on = t.id === panelId;
          t.tab.classList.toggle('is-active', on);
          t.tab.setAttribute('aria-selected', on ? 'true' : 'false');
          t.panel.hidden = !on;
        });
      }
    }

    if (!window.customElements.get('product-drawers')) {
      window.customElements.define('product-drawers', ProductDrawers);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-form"] && !Shopify.designMode) return;
  try {
    (function () {
    // Smooth-scroll to the first featured-products section (the similar products
    // carousel), reduced-motion aware. Shared by the out-of-stock "See similar"
    // button and the discontinued message.
    function scrollToFeaturedProducts() {
      var target = document.querySelector('.featured-products-section');
      if (!target) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    class StickyAtc extends HTMLElement {
      connectedCallback() {
        // Moving the element below re-fires connectedCallback; guard against
        // re-entry so setup runs once.
        if (this.__init) return;
        this.__init = true;

        var self = this;
        var scope = this.closest('.product') || document;
        var mainAtc = scope.querySelector('[data-atc]');
        var footer = document.querySelector('.footer');

        // Portal the bar to <body> so it escapes any ancestor stacking context.
        // On desktop .product__info is position:sticky (a stacking context), which
        // would otherwise trap this fixed bar and let later sections paint over it.
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
        }

        this.atcPassed = false;
        this.footerIn = false;

        function update() {
          var visible = self.atcPassed && !self.footerIn;
          self.classList.toggle('is-visible', visible);

          // Publish the bar's presence and measured height on <html> so fixed
          // chrome owned by other files can move out of its way - the Zendesk
          // chat launcher sits bottom-right and was covering the button on
          // mobile (client UAT, #1018). Measured rather than hard-coded: the
          // height depends on whether the product has a thumbnail and on how the
          // title and its metas wrap.
          var root = document.documentElement;
          if (visible) {
            root.style.setProperty('--sticky-atc-height', self.offsetHeight + 'px');
          }
          root.classList.toggle('sticky-atc-visible', visible);
        }

        if (!('IntersectionObserver' in window)) return;

        if (mainAtc) {
          this.atcObserver = new IntersectionObserver(function (entries) {
            var entry = entries[0];
            /* The bar stands in for the real button, so it only belongs on screen
               once the reader has scrolled PAST that button - not simply whenever
               the button is off screen (design QA 5230031). Off the bottom means
               they have not reached it yet, and the real button is on its way, so
               a duplicate would be noise. Comparing the button's bottom edge to
               the top of the viewport distinguishes the two directions; a plain
               isIntersecting check cannot. rootBounds is null in some cross
               origin cases, hence the fallback to 0. */
            var viewportTop = entry.rootBounds ? entry.rootBounds.top : 0;
            self.atcPassed = !entry.isIntersecting &&
              entry.boundingClientRect.bottom <= viewportTop;
            update();
          });
          this.atcObserver.observe(mainAtc);
        }
        if (footer) {
          this.footerObserver = new IntersectionObserver(function (entries) {
            self.footerIn = entries[0].isIntersecting;
            update();
          });
          this.footerObserver.observe(footer);
        }
      }

      disconnectedCallback() {
        if (this.atcObserver) this.atcObserver.disconnect();
        if (this.footerObserver) this.footerObserver.disconnect();
        // The flag lives on <html>, which outlives this element (the theme
        // editor removes and re-adds blocks), so clear it on the way out or the
        // launcher stays lifted over a bar that is no longer there.
        document.documentElement.classList.remove('sticky-atc-visible');
      }
    }

    if (!customElements.get('sticky-atc')) {
      customElements.define('sticky-atc', StickyAtc);
    }

    // Out-of-stock notify-me capture. On submit it validates the email and swaps
    // to the success state; the "See similar" button scrolls to the first
    // featured-products section. The email is not sent anywhere yet - the
    // back-in-stock backend is unconfirmed (task #18383166), so we announce it via
    // the notify-stock:submit event for the chosen app to bind to.
    class NotifyStock extends HTMLElement {
      connectedCallback() {
        if (this.__init) return;
        this.__init = true;
        this.form = this.querySelector('[data-notify-form]');
        this.defaultMsg = this.querySelector('[data-oos-default]');
        this.successMsg = this.querySelector('[data-oos-success]');
        this.similar = this.querySelector('[data-oos-similar]');
        this.onSubmit = this.onSubmit.bind(this);
        this.onSimilar = this.onSimilar.bind(this);
        if (this.form) this.form.addEventListener('submit', this.onSubmit);
        if (this.similar) this.similar.addEventListener('click', this.onSimilar);
      }

      onSubmit(event) {
        event.preventDefault();
        var email = this.form.querySelector('input[type="email"]');
        if (email && !email.checkValidity()) {
          email.reportValidity();
          return;
        }
        this.dispatchEvent(new CustomEvent('notify-stock:submit', {
          bubbles: true,
          detail: {
            email: email ? email.value : '',
            productId: this.getAttribute('data-product-id'),
            variantId: this.getAttribute('data-variant-id')
          }
        }));
        if (this.form) this.form.hidden = true;
        if (this.defaultMsg) this.defaultMsg.hidden = true;
        if (this.successMsg) this.successMsg.hidden = false;
        // Only reveal "See similar" if the page actually has a featured-products
        // section to scroll to; otherwise leave it hidden.
        if (this.similar) {
          this.similar.hidden = !document.querySelector('.featured-products-section');
        }
      }

      onSimilar() {
        scrollToFeaturedProducts();
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        if (this.similar) this.similar.removeEventListener('click', this.onSimilar);
      }
    }

    if (!customElements.get('notify-stock')) {
      customElements.define('notify-stock', NotifyStock);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-mix-match"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.customElements || customElements.get('mix-match-buybox')) return;

    customElements.define(
      'mix-match-buybox',
      class extends HTMLElement {
        connectedCallback() {
          if (this.__init) return;
          this.__init = true;

          var configEl = this.querySelector('[data-mm-config]');
          if (!configEl) return;
          try {
            this.config = JSON.parse(configEl.textContent);
          } catch (err) {
            return;
          }

          this.form = this.querySelector('[data-mm-form]');
          this.currency = this.getAttribute('data-currency') || 'AUD';
          this.placeEditorialMedia();
          var priceRoot = this.querySelector('[data-mm-price]');
          this.moneyFormat = priceRoot ? priceRoot.getAttribute('data-money-format') : '';
          this.hcLabel = priceRoot ? priceRoot.getAttribute('data-hc-label') : '';
          this.savings = parseInt(this.getAttribute('data-savings-percent') || '0', 10) || 0;
          this.titleFixed = this.hasAttribute('data-title-fixed');
          // The gallery's first media cell hosts the composite / stacked
          // imagery. The cell may be an image-less placeholder - a master
          // pseudo-product often has no media of its own - so the img is
          // optional and the cell is the anchor.
          this.galleryCells = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-grid] .product__media-cell'));
          this.galleryCell = this.galleryCells[0] || null;
          this.galleryImg = this.galleryCell ? this.galleryCell.querySelector('img') : null;
          if (this.galleryImg) {
            this.galleryOriginal = {
              src: this.galleryImg.getAttribute('src'),
              srcset: this.galleryImg.getAttribute('srcset'),
              sizes: this.galleryImg.getAttribute('sizes')
            };
          }

          // Posting is owned by the product section's generic form handler
          // (sections/product.liquid setupForm: it grabs the first <form> in
          // <product-form> and AJAX-posts it) - a second submit handler here
          // would double-add. Instead the hidden inputs are kept correct at
          // all times: _mm_group is minted now and re-minted after every
          // cart:updated so each add groups separately.
          this.groupId = this.uuid();
          this.onChange = this.onChange.bind(this);
          this.onCartUpdated = this.onCartUpdated.bind(this);
          this.form.addEventListener('change', this.onChange);
          this.form.addEventListener('input', this.onChange);
          document.addEventListener('cart:updated', this.onCartUpdated);

          var self = this;
          this.querySelectorAll('[data-mm-options]').forEach(function (track) {
            self.setupDrag(track);
            self.setupNav(track);
          });

          this.hydrateFromUrl();
          this.sync();
        }

        // Drag-to-scroll for mouse/pen - same pattern as featured-products /
        // hero / shop-by-category (see the carousel drag write-up: native image
        // dragstart hijacks the gesture and eats pointerup, and a bare
        // overflow scroller has no mouse drag at all). The capture-phase click
        // suppression matters doubly here: the slides are radio labels, so a
        // drag that ended on one would otherwise silently change the selection.
        setupDrag(track) {
          if (track.__mmDragInit) return;
          track.__mmDragInit = true;

          var DRAG_THRESHOLD = 5;
          var dragging = false;
          var moved = false;
          var pointerId = null;
          var startX = 0;
          var startLeft = 0;

          function release() {
            if (pointerId == null) return;
            if (track.releasePointerCapture && track.hasPointerCapture && track.hasPointerCapture(pointerId)) {
              try { track.releasePointerCapture(pointerId); } catch (err) {}
            }
            pointerId = null;
          }

          track.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'touch') return; // native touch scrolling handles this
            if (e.button !== 0) return;
            if (track.scrollWidth <= track.clientWidth) return;
            dragging = true;
            moved = false;
            pointerId = e.pointerId;
            startX = e.clientX;
            startLeft = track.scrollLeft;
            track.classList.add('is-dragging');
          });

          track.addEventListener('pointermove', function (e) {
            if (!dragging || e.pointerId !== pointerId) return;
            var dx = e.clientX - startX;
            if (!moved) {
              if (Math.abs(dx) <= DRAG_THRESHOLD) return;
              moved = true;
              // Capture only once it is genuinely a drag - capturing on
              // pointerdown would retarget an ordinary option click.
              if (track.setPointerCapture) {
                try { track.setPointerCapture(pointerId); } catch (err) {}
              }
            }
            e.preventDefault();
            track.scrollLeft = startLeft - dx;
          });

          function end(e) {
            if (!dragging || (e && e.pointerId !== pointerId)) return;
            dragging = false;
            track.classList.remove('is-dragging');
            release();
          }

          track.addEventListener('pointerup', end);
          track.addEventListener('pointercancel', end);

          track.addEventListener('click', function (e) {
            if (!moved) return;
            e.preventDefault();
            e.stopPropagation();
            moved = false;
          }, true);

          track.addEventListener('dragstart', function (e) { e.preventDefault(); });
        }

        // Prev/next arrows over the options track (Figma shows the next arrow
        // overlapping the last visible thumb). Hidden at the ends and entirely
        // when there is nothing to scroll.
        setupNav(track) {
          var wrap = track.parentElement;
          if (!wrap || track.__mmNavInit) return;
          track.__mmNavInit = true;
          var buttons = wrap.querySelectorAll('[data-mm-nav]');
          if (!buttons.length) return;

          function step() {
            var slide = track.querySelector('.mix-match__option');
            return slide ? slide.getBoundingClientRect().width + 8 : track.clientWidth * 0.8;
          }

          function update() {
            var max = track.scrollWidth - track.clientWidth;
            buttons.forEach(function (btn) {
              var dir = parseInt(btn.getAttribute('data-mm-nav'), 10);
              var hide = max <= 1 || (dir < 0 ? track.scrollLeft <= 1 : track.scrollLeft >= max - 1);
              btn.hidden = hide;
            });
          }

          buttons.forEach(function (btn) {
            btn.addEventListener('click', function () {
              track.scrollBy({ left: parseInt(btn.getAttribute('data-mm-nav'), 10) * step(), behavior: 'smooth' });
            });
          });
          track.addEventListener('scroll', update, { passive: true });
          window.addEventListener('resize', update);
          update();
        }

        disconnectedCallback() {
          if (!this.form) return;
          this.form.removeEventListener('change', this.onChange);
          this.form.removeEventListener('input', this.onChange);
          document.removeEventListener('cart:updated', this.onCartUpdated);
        }

        onCartUpdated() {
          this.groupId = this.uuid();
          this.sync();
        }

        selection() {
          var out = {};
          var self = this;
          this.config.components.forEach(function (comp) {
            var checked = self.form.querySelector('input[name="mm-' + comp.role + '"]:checked');
            var handle = checked ? checked.value : null;
            if (handle && comp.products[handle]) {
              out[comp.role] = { handle: handle, data: comp.products[handle] };
            }
          });
          return out;
        }

        /* ?shade=<handle>&base=<handle>. Only sellable handles can be honoured,
           because an unsellable component is not rendered as an option at all.
           A mistyped or stale handle still quietly keeps the default selection.

           #1110, Alex 14 Sep: a handle we recognise as SOLD OUT no longer stays
           quiet. It used to be indistinguishable from a typo - both simply fell
           through to the default - so a link to a specific pairing loaded a
           DIFFERENT product, at a possibly different price, with nothing said.
           The config's `unavailable` map is what makes the two cases tellable
           apart, and gives us the product's name to show. */
        hydrateFromUrl() {
          var params = new URLSearchParams(window.location.search);
          var self = this;
          var goneTitles = [];
          this.config.components.forEach(function (comp) {
            var handle = params.get(comp.role);
            if (!handle) return;
            if (!comp.products[handle]) {
              var title = comp.unavailable && comp.unavailable[handle];
              if (title) goneTitles.push(String(title));
              return;
            }
            var input = self.form.querySelector('input[name="mm-' + comp.role + '"][value="' + handle + '"]');
            if (input) input.checked = true;
          });
          if (goneTitles.length) { this.showNotice(self.unavailableMessage(goneTitles)); }
        }

        /* The wording both paths share, so a component that sells out before
           the page loads and one that sells out before the add reads the same
           way. Shopify's own 422 sentence also names the product, and the
           add-to-cart handler in sections/product.liquid shows that verbatim
           into this very element. */
        unavailableMessage(titles) {
          var list = titles.length > 1
            ? titles.slice(0, -1).join(', ') + ' and ' + titles[titles.length - 1]
            : titles[0];
          var verb = titles.length > 1 ? ' are ' : ' is ';
          return list + verb + 'no longer available, so we have selected an alternative.';
        }

        /* Writes into the shared [data-cart-add-error] element, which sits
           under the add to cart button. Empty text clears and hides it. */
        showNotice(text) {
          var box = this.form && this.form.querySelector('[data-cart-add-error]');
          if (!box) return;
          box.textContent = text || '';
          box.hidden = !text;
        }

        /* The shop's own money format, the same idiom
           snippets/collection-card-meta.liquid uses, so client-painted prices
           read exactly like the Liquid-rendered ones. Intl.NumberFormat was
           printing "A$158" for AUD - correct for the locale, wrong for the
           design, which wants a plain "$158". The format's braces are built
           from char codes because a literal Liquid-looking token inside a
           javascript tag is flagged by Theme Check, and Liquid is not rendered
           in here anyway. */
        money(cents) {
          var whole = Math.floor(Math.abs(cents) / 100);
          var rem = Math.abs(cents) % 100;
          var out = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          /* Cents ALWAYS, including .00: Liquid's `money` filter keeps them and
             every other price on the site shows them ("$1,699.00" on an ordinary
             PDP), so dropping them here would make the M&M total the only price
             in the theme formatted differently - and the server-rendered initial
             state, which uses `money`, would disagree with the script's repaint.
             collection-card-meta drops them deliberately for its "From $199"
             card line; this is the PDP price, so it follows `money`. */
          out = out + '.' + (rem < 10 ? '0' + rem : String(rem));
          if (cents < 0) out = '-' + out;
          var format = this.moneyFormat;
          if (!format) return '$' + out;
          var open = String.fromCharCode(123, 123);
          var close = String.fromCharCode(125, 125);
          var start = format.indexOf(open);
          var end = format.indexOf(close);
          if (start < 0 || end < start) return '$' + out;
          return format.slice(0, start) + out + format.slice(end + 2);
        }

        /* The editorial image is AUTHORED in this block and MOVED to where the
           design wants it, which is how sections/product.liquid stays at a zero
           diff. Same technique this block already uses to put the composite into
           the gallery.

           Two anchors, because the theme ships two editorials and hides one per
           breakpoint: the stacked panel below 1104px and the gallery cell above
           it. Each copy goes to its own anchor and is revealed only if its anchor
           exists; an anchor that is missing simply leaves that copy hidden, so a
           template without an editorial card renders nothing extra. */
        placeEditorialMedia() {
          var mobile = this.querySelector('[data-mm-editorial-media="mobile"]');
          var desktop = this.querySelector('[data-mm-editorial-media="desktop"]');

          var panel = document.querySelector('.product__editorial-mobile');
          if (mobile && panel && mobile.parentNode !== panel) {
            panel.appendChild(mobile);
            mobile.hidden = false;
          }

          /* Below the editorial CELL, not inside it: the design asks for a
             full-width band under the card, and the cell is one grid item. */
          var cell = document.querySelector('[data-gallery-grid] .product__editorial');
          if (desktop && cell && desktop.previousElementSibling !== cell) {
            cell.parentNode.insertBefore(desktop, cell.nextSibling);
            desktop.hidden = false;
          }
        }

        onChange() {
          /* The shopper has moved on from whatever the notice was about, so it
             stops applying the moment they pick something else (Alex, 14 Sep).
             Leaving it up would attach a stale complaint to a fresh selection. */
          this.showNotice('');
          this.sync();
        }

        /* Drives snippets/price.liquid's contract, which the markup above
           reproduces. `was` is the greater of the components' compare-at sum
           and their plain sum, so a component on its own sale shows a was even
           when the block sets no savings percentage. With nothing to compare
           the pair is hidden and the plain amount shows instead, which is how
           the snippet collapses too. */
        paintPrice(total, payable, compareTotal, hcTotal) {
          var root = this.querySelector('[data-mm-price]');
          if (!root) return;
          var was = Math.max(compareTotal || 0, total);
          var onSale = was > payable;

          /* STRICTLY greater. AU components commonly carry a compare_at equal to
             their price, which sums to was === payable - that is NOT a sale, and
             must show the plain amount only. */
          root.classList.toggle('price--sale', onSale);
          var compareEl = root.querySelector('[data-mm-price-compare]');
          var groupEl = root.querySelector('[data-mm-price-group]');
          var wasLabel = root.querySelector('[data-mm-price-was-label]');
          var saleEl = root.querySelector('[data-mm-price-sale]');
          var plainEl = root.querySelector('[data-mm-price-plain]');
          /* Every element of BOTH paths is set on every repaint, so exactly one
             of the group and the plain amount can ever be visible - including
             the visually-hidden labels, which have to move with their row or a
             screen reader hears both "Regular price" and the plain path. */
          if (compareEl) { compareEl.textContent = this.money(was); compareEl.hidden = !onSale; }
          if (wasLabel) wasLabel.hidden = !onSale;
          if (groupEl) groupEl.hidden = !onSale;
          if (saleEl) saleEl.textContent = this.money(payable);
          if (plainEl) { plainEl.textContent = this.money(payable); plainEl.hidden = onSale; }

          /* Pill: percentage DERIVED from the summed was/now, so the pill, the
             price and the cart chip all read one truth. Hidden when there is no
             saving to state. */
          var pillEl = this.querySelector('[data-mm-pill]');
          if (pillEl) {
            var tpl = pillEl.getAttribute('data-pill-template') || '';
            if (onSale && tpl) {
              var pct = Math.round((was - payable) * 100 / was);
              pillEl.textContent = tpl
                .split('$promo_discount_percentage').join(String(pct))
                .split('$promo_saving').join(this.money(was - payable));
            }
            pillEl.hidden = !onSale;
          }

          var hcEl = root.querySelector('[data-mm-price-hc]');
          if (hcEl) {
            var show = hcTotal > 0 && hcTotal < payable;
            if (show && this.hcLabel) {
              hcEl.textContent = this.hcLabel.split('__MM_AMOUNT__').join(this.money(hcTotal));
            }
            hcEl.hidden = !show;
          }
        }

        sync() {
          var selection = this.selection();
          var self = this;
          var total = 0;
          var promoTotal = 0;
          var compareTotal = 0;
          var hcTotal = 0;
          var hcAll = true;
          var titleParts = [];
          var params = new URLSearchParams(window.location.search);

          this.config.components.forEach(function (comp) {
            var sel = selection[comp.role];
            if (!sel) return;
            total += sel.data.price;
            /* promoPrice is this component's REAL payable price, resolved
               server-side; wasPrice is its own was. Summing the real numbers is
               the whole pricing model - there is no percentage anywhere. */
            /* > 0, not just "is a number": a zero means the resolution produced
               nothing and must fall back to the selling price. Printing $0.00 is
               the worst failure this block has, so it is guarded per component
               and again on the total below. */
            promoTotal += (typeof sel.data.promoPrice === 'number' && sel.data.promoPrice > 0)
              ? sel.data.promoPrice
              : sel.data.price;
            compareTotal += typeof sel.data.wasPrice === 'number' ? sel.data.wasPrice : sel.data.price;
            if (sel.data.homeclub > 0) { hcTotal += sel.data.homeclub; } else { hcAll = false; }
            titleParts.push(sel.data.short);
            params.set(comp.role, sel.handle);

            var titleEl = self.querySelector('[data-mm-selected-title="' + comp.role + '"]');
            var priceEl = self.querySelector('[data-mm-selected-price="' + comp.role + '"]');
            var linkEl = self.querySelector('[data-mm-product-link="' + comp.role + '"]');
            var idInput = self.querySelector('[data-mm-item-id="' + comp.role + '"]');
            if (titleEl) titleEl.textContent = sel.data.title;
            if (priceEl) priceEl.textContent = self.money(sel.data.price);
            if (linkEl) linkEl.href = sel.data.url;
            if (idInput) idInput.value = sel.data.variantId;
          });

          /* Announce the selection so other blocks can follow it. The store
             locator's delivery panel listens: it resolves its estimate from the
             SELECTED components, so it has to re-resolve whenever they change.
             Handles only - the listener fetches its own delivery inputs per
             component, exactly as the native-bundle path does. */
          document.dispatchEvent(new CustomEvent('mix-match:change', {
            bubbles: true,
            detail: {
              master: this.getAttribute('data-mm-master') || '',
              handles: this.config.components
                .map(function (comp) { return selection[comp.role] ? selection[comp.role].handle : null; })
                .filter(Boolean)
            }
          }));

          if (!this.titleFixed) {
            var titleEl = this.querySelector('[data-mm-title]');
            if (titleEl && titleParts.length) titleEl.textContent = titleParts.join(' ' + this.config.titleJoiner + ' ');
          }

          /* savings_percent no longer touches the price. Payable is the summed
             per-component promo price; the setting is display-only now. */
          var payable = promoTotal > 0 ? promoTotal : total;
          this.paintPrice(total, payable, compareTotal, hcAll ? hcTotal : 0);
          var atcPriceEl = this.querySelector('[data-mm-atc-price]');
          if (atcPriceEl) atcPriceEl.textContent = this.money(payable);

          // Keep the posted lines truthful at all times: the section's form
          // handler snapshots these inputs the moment ATC is pressed.
          var qtyInput = this.querySelector('input[name="mm-quantity"]');
          var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          var groupId = this.groupId;
          this.form.querySelectorAll('[data-mm-item-group]').forEach(function (input) {
            input.value = groupId;
          });
          this.form.querySelectorAll('[data-mm-item-qty]').forEach(function (input) {
            input.value = qty;
          });

          this.syncGallery(selection);

          // Keep the combo shareable without polluting history.
          if (window.history && window.history.replaceState) {
            var query = params.toString();
            window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : ''));
          }

          this.syncSeo(selection, titleParts);
        }

        // Rendered SEO per combo: Google indexes what the renderer sees, so
        // the canonical and document title follow the selection. The
        // canonical carries ONLY the component params - never preview/view
        // noise - so each combination canonicalises to its own clean URL
        // (the combo sitemap serves the same URLs).
        syncSeo(selection, titleParts) {
          var params = new URLSearchParams();
          this.config.components.forEach(function (comp) {
            if (selection[comp.role]) params.set(comp.role, selection[comp.role].handle);
          });
          var comboUrl = params.toString()
            ? window.location.origin + window.location.pathname + '?' + params.toString()
            : null;
          var canonical = document.querySelector('link[rel="canonical"]');
          if (canonical && comboUrl) canonical.href = comboUrl;
          var ogUrl = document.querySelector('meta[property="og:url"]');
          if (ogUrl && comboUrl) ogUrl.setAttribute('content', comboUrl);
          if (!this.titleFixed && titleParts.length) {
            if (this.titleTail === undefined) {
              var split = document.title.split('-');
              this.titleTail = split.length > 1 ? split[split.length - 1] : null;
            }
            var composed = titleParts.join(' ' + this.config.titleJoiner + ' ');
            document.title = composed + (this.titleTail ? ' -' + this.titleTail : '');
            var ogTitle = document.querySelector('meta[property="og:title"]');
            if (ogTitle) ogTitle.setAttribute('content', composed);
          }
        }

        // Gallery hero priority: bespoke pairing image (metaobject) > stacked
        // two-image fallback (client steer 19 Aug: don't wait on AI imagery)
        // > the master product's own media.
        syncGallery(selection) {
          if (!this.galleryCell) return;
          var ordered = [];
          this.config.components.forEach(function (comp) {
            if (selection[comp.role]) ordered.push(selection[comp.role]);
          });
          var key = ordered.map(function (s) { return s.handle; }).sort().join('|');
          var composite = this.config.pairingImages[key];
          var canStack = this.hasAttribute('data-stack-enabled') &&
            ordered.length >= 2 && ordered.every(function (s) { return !!s.data.image; });

          this.syncComponentCells(ordered);

          this.removeStack();

          if (composite) {
            if (this.galleryImg) {
              this.galleryImg.removeAttribute('srcset');
              this.galleryImg.removeAttribute('sizes');
              this.galleryImg.setAttribute('src', composite);
            } else {
              this.buildStack([{ data: { image: composite, title: '' } }]);
            }
            return;
          }

          this.restoreGalleryImg();
          if (canStack) this.buildStack(ordered);
        }

        // Figma's gallery pairs the hero with one image per component (the
        // "Horizontal Image Set"): cells 2 and 3 show the selected shade and
        // base on their own, updated with the selection. Desktop shows them
        // as the grid's second row; the mobile carousel gets them as slides.
        syncComponentCells(ordered) {
          for (var i = 0; i < 2; i++) {
            var cell = this.galleryCells[i + 1];
            if (!cell) continue;
            var img = cell.querySelector('.mm-cell-img');
            var sel = ordered[i];
            /* cellImage, not image: the cells show one component on its own,
               so they take the product's own packshot and multiply it into the
               cell. The cutout stays for the composite, which needs alpha. */
            var cellSrc = sel ? (sel.data.cellImage || sel.data.image) : null;
            if (sel && cellSrc) {
              if (!img) {
                img = document.createElement('img');
                img.className = 'mm-cell-img';
                cell.style.position = 'relative';
                cell.appendChild(img);
              }
              img.src = cellSrc;
              img.alt = sel.data.title;
            } else if (img) {
              img.parentNode.removeChild(img);
            }
          }
        }

        restoreGalleryImg() {
          if (!this.galleryImg || !this.galleryOriginal) return;
          if (this.galleryOriginal.srcset) this.galleryImg.setAttribute('srcset', this.galleryOriginal.srcset);
          if (this.galleryOriginal.sizes) this.galleryImg.setAttribute('sizes', this.galleryOriginal.sizes);
          this.galleryImg.setAttribute('src', this.galleryOriginal.src);
        }

        removeStack() {
          if (this.stackEl && this.stackEl.parentNode) this.stackEl.parentNode.removeChild(this.stackEl);
          this.stackEl = null;
          if (this.galleryImg) this.galleryImg.style.removeProperty('visibility');
        }

        buildStack(ordered) {
          var cell = this.galleryCell;
          if (!cell) return;
          var direction = this.getAttribute('data-stack-direction') || 'top-bottom';
          var overlap = parseInt(this.getAttribute('data-stack-overlap') || '20', 10) || 0;
          var zOrder = this.getAttribute('data-stack-z') || 'first';

          var stack = document.createElement('div');
          stack.className = 'mm-composite mm-composite--' + direction + ' mm-composite--z-' + zOrder;
          stack.style.setProperty('--mm-overlap', overlap + '%');
          for (var i = 0; i < 2; i++) {
            var img = document.createElement('img');
            img.src = ordered[i].data.image;
            img.alt = ordered[i].data.title;
            img.className = 'mm-composite__img mm-composite__img--' + (i === 0 ? 'first' : 'second');
            stack.appendChild(img);
          }
          // The original hero keeps its layout box (visibility, not display)
          // so the media cell's aspect ratio never collapses mid-swap. A
          // media-less master renders placeholder cells with no img at all.
          if (this.galleryImg) this.galleryImg.style.visibility = 'hidden';
          cell.style.position = 'relative';
          cell.appendChild(stack);
          this.stackEl = stack;
        }

        uuid() {
          if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
          return 'mm-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        }

      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-options"] && !Shopify.designMode) return;
  try {
    (function () {
    /* The size info icon opens the "Specs & Dimensions" drawer. The drawer item
       (product-specs-dimensions) is only in the DOM when the drawer exists and is
       populated, so we reveal the icon only when its trigger is found, and defer
       the open to that trigger (reusing the drawer container's open/focus logic). */
    /* Both option-head info icons do the same job: scroll to the section that
       expands on their option. Each is rendered hidden and revealed only when
       its section is on the page and rendering - both sections emit nothing when
       the product data can't fill them - so the icon mirrors its presence.
       Section ids are per-instance, hence the data hooks rather than anchors. */
    function wireSectionLinks(root, linkAttr, targetAttr, flag) {
      (root || document).querySelectorAll('[' + linkAttr + ']').forEach(function (link) {
        if (link[flag]) return;
        var target = document.querySelector('[' + targetAttr + ']');
        /* offsetParent covers a section that is present but hidden (the standard
           show_mobile / show_desktop settings). */
        if (!target || target.offsetParent === null) return;
        link[flag] = true;
        link.hidden = false;
        link.addEventListener('click', function () {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
          var top = target.getBoundingClientRect().top + window.pageYOffset - headerH;
          window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    }

    function wireOptionLinks(root) {
      wireSectionLinks(root, 'data-finishes-link', 'data-product-finishes', '__finishesInit');
      wireSectionLinks(root, 'data-specs-link', 'data-product-specs', '__specsInit');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { wireOptionLinks(); });
    } else {
      wireOptionLinks();
    }
    /* The Finishes section may load after this block, so re-run on any section
       load, not just this one's. */
    document.addEventListener('shopify:section:load', function () { wireOptionLinks(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-price"] && !Shopify.designMode) return;
  try {
    (function () {
    // Jump from the PDP rating to the reviews section. Section ids are
    // per-instance, so the target is resolved by class, and at click time so a
    // reviews section that loads after this block still works.
    function reviewsTarget() {
      var sections = document.querySelectorAll('.section--reviews');
      for (var i = 0; i < sections.length; i++) {
        // offsetParent covers a reviews section that is present but hidden (the
        // show_mobile / show_desktop settings, or its own hide-when-empty).
        if (sections[i].offsetParent !== null) return sections[i];
      }
      return null;
    }

    function scrollToReviews() {
      var target = reviewsTarget();
      if (!target) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerH;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    }

    function wireRatings(root) {
      (root || document).querySelectorAll('[data-reviews-scroll]').forEach(function (button) {
        // No reviews section on the page: keep it as non-interactive text.
        button.disabled = reviewsTarget() === null;
        if (button.__reviewsScrollInit) return;
        button.__reviewsScrollInit = true;
        button.addEventListener('click', scrollToReviews);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { wireRatings(); });
    } else {
      wireRatings();
    }
    // The reviews section can load or be removed after this block (theme editor,
    // hide-when-empty), so re-check on any section load.
    document.addEventListener('shopify:section:load', function () { wireRatings(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-store-locator"] && !Shopify.designMode) return;
  try {
    (function () {
    var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    var STORAGE_KEY = 'es:store-locator';

    /* ---------- Request delivery quote: Zendesk action ----------
       Only bound when the merchant picked "Open Zendesk chat" - Liquid emits
       data-rdq-zendesk on the CTA instead of a drawer trigger. Delegated on
       document because the no-nearby panel is revealed by the controller after
       a postcode lookup, so the button may not exist when this runs.

       typeof guard rather than a bare "if (zE)": when the Zendesk embed has not
       loaded, zE is an UNDECLARED identifier and the bare check throws a
       ReferenceError that would kill the handler silently. Messaging first
       (newer edition), Classic as the fallback - the account can be on either. */
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-rdq-zendesk]');
      if (!trigger) return;
      event.preventDefault();
      if (typeof zE !== 'function') return;
      try {
        zE('messenger', 'open');
      } catch (messagingErr) {
        try {
          zE('webWidget', 'open');
        } catch (classicErr) {
          /* Neither API target valid - widget misconfigured. No-op. */
        }
      }
    });

    // Google Maps "Ultra Light with Labels" theme.
    var MAP_STYLE = [
      { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#e9e9e9' }, { lightness: 17 }] },
      { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#f5f5f5' }, { lightness: 20 }] },
      { featureType: 'road.highway', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }, { lightness: 17 }] },
      { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }] },
      { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#ffffff' }, { lightness: 18 }] },
      { featureType: 'road.local', elementType: 'geometry', stylers: [{ color: '#ffffff' }, { lightness: 16 }] },
      { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#f5f5f5' }, { lightness: 21 }] },
      { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#dedede' }, { lightness: 21 }] },
      { elementType: 'labels.text.stroke', stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { lightness: 16 }] },
      { elementType: 'labels.text.fill', stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }] },
      { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#f2f2f2' }, { lightness: 19 }] },
      { featureType: 'administrative', elementType: 'geometry.fill', stylers: [{ color: '#fefefe' }, { lightness: 20 }] },
      { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }] }
    ];

    function ready(fn) {
      if (document.readyState !== 'loading') { fn(); }
      else { document.addEventListener('DOMContentLoaded', fn); }
    }

    // Format a 24h "HH:MM" into "9am" / "5:30pm".
    function fmtTime(hhmm) {
      var parts = hhmm.split(':');
      var h = parseInt(parts[0], 10);
      var m = parseInt(parts[1], 10);
      var ampm = h < 12 ? 'am' : 'pm';
      var hr = h % 12;
      if (hr === 0) { hr = 12; }
      var mm = m < 10 ? '0' + m : String(m);
      return hr + ':' + mm + ampm;
    }

    // "09:00-17:30" -> { open: 540, close: 1050, label: "9am-5:30pm" } or null.
    // True when the store carries opening hours for at least one day. Distinguishes
    // "shut right now" from "we do not know this store's hours" (#19498862).
    function hasAnyHours(store) {
      for (var i = 0; i < DAYS.length; i++) {
        if ((store.getAttribute('data-hours-' + DAYS[i]) || '').trim()) { return true; }
      }
      return false;
    }

    function parseRange(raw) {
      if (!raw) { return null; }
      var bits = raw.split('-');
      if (bits.length !== 2) { return null; }
      var o = bits[0].trim().split(':');
      var c = bits[1].trim().split(':');
      if (o.length !== 2 || c.length !== 2) { return null; }
      var openMin = parseInt(o[0], 10) * 60 + parseInt(o[1], 10);
      var closeMin = parseInt(c[0], 10) * 60 + parseInt(c[1], 10);
      if (isNaN(openMin) || isNaN(closeMin)) { return null; }
      return {
        open: openMin,
        close: closeMin,
        label: fmtTime(bits[0].trim()) + ' - ' + fmtTime(bits[1].trim())
      };
    }

    // Current weekday index + minutes-of-day in a given IANA timezone.
    function nowInTz(tz) {
      try {
        var fmt = new Intl.DateTimeFormat('en-AU', {
          timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
        });
        var parts = fmt.formatToParts(new Date());
        var wd = '', hh = 0, mm = 0;
        for (var i = 0; i < parts.length; i++) {
          if (parts[i].type === 'weekday') { wd = parts[i].value.toLowerCase().slice(0, 3); }
          if (parts[i].type === 'hour') { hh = parseInt(parts[i].value, 10) % 24; }
          if (parts[i].type === 'minute') { mm = parseInt(parts[i].value, 10); }
        }
        var idx = DAYS.indexOf(wd);
        return { dayIndex: idx, minutes: hh * 60 + mm };
      } catch (e) {
        return null;
      }
    }

    function haversine(lat1, lng1, lat2, lng2) {
      var R = 6371;
      var dLat = (lat2 - lat1) * Math.PI / 180;
      var dLng = (lng2 - lng1) * Math.PI / 180;
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function init() {
      var root = document.querySelector('[data-store-locator]');
      var drawer = document.querySelector('[data-sl-drawer]');
      if (!root || !drawer) { return; }

      var stores = Array.prototype.slice.call(drawer.querySelectorAll('[data-sl-store]'));
      var list = drawer.querySelector('[data-sl-list]');
      /* The two-person lift callout (#901). It is rendered AFTER the locator
         div closes, so it is a SIBLING of `root`, not a descendant - a
         root.querySelector for it silently finds nothing. Scope the lookup to
         the shared parent (the block wrapper) rather than the document, so a
         second instance of this block on one page cannot capture the wrong one. */
      var bulkyCallout = root.parentNode ? root.parentNode.querySelector('[data-sl-bulky-callout]') : null;
      var toofar = drawer.querySelector('[data-sl-toofar]');
      var toofarLine = drawer.querySelector('[data-sl-toofar-line]');
      var toofarHeading = drawer.querySelector('[data-sl-toofar-heading]');
      var toofarLimit = parseFloat(root.getAttribute('data-toofar-distance')) || 0;
      var toofarTpl = root.getAttribute('data-toofar-line') || '';
      /* The callout needs the search AND the Rex answer. They arrive
         independently, so each stores its result and re-runs the check; whichever
         lands second is the one that shows the panel. */
      var toofarStock = null;
      var toofarLocated = false;
      var empty = drawer.querySelector('[data-sl-empty]');
      var dataEl = drawer.querySelector('[data-sl-locations]') ||
        document.querySelector('[data-sl-locations]');
      var locations = [];
      if (dataEl) {
        try { locations = JSON.parse(dataEl.textContent); } catch (e) { locations = []; }
      }

      var inline = root.querySelector('[data-sl-inline]');
      var selected = root.querySelector('[data-sl-selected]');
      var selectedNames = root.querySelectorAll('[data-sl-selected-name]');
      var selectedPostcode = root.querySelector('[data-sl-postcode]');
      var postcodeRow = root.querySelector('[data-sl-postcode-row]');
      var postcodeLabel = root.querySelector('[data-sl-postcode-label]');
      var postcodeLabelEmpty = root.querySelector('[data-sl-postcode-label-empty]');
      var postcodeStatus = root.querySelector('[data-sl-postcode-status]');
      var postcodePrompt = root.querySelector('[data-sl-postcode-prompt]');
      var collectRow = root.querySelector('[data-sl-collect-row]');
      var collectLabel = root.querySelector('[data-sl-collect-label]');
      var collectLabelEmpty = root.querySelector('[data-sl-collect-label-empty]');
      var collectSuffix = root.querySelector('[data-sl-collect-suffix]');
      var collectStatus = root.querySelector('[data-sl-collect-status]');
      var collectPrompt = root.querySelector('[data-sl-collect-prompt]');
      var storeRows = root.querySelectorAll('[data-sl-store-row]');
      var onlineOnly = root.querySelector('[data-sl-online-only]');
      var delivery = root.querySelector('[data-sl-delivery]');
      var noNearby = root.querySelector('[data-sl-no-nearby]');
      /* TWO buttons carry this hook since #1158 - the selected panel's and the
         no-delivery panel's - and they must read the same. querySelectorAll,
         not querySelector: the singular form would have updated whichever came
         first in the DOM and left the other stuck on its server-rendered
         label. */
      var changeLocationLabels = root.querySelectorAll('[data-sl-change-location] .button__label');

      // Delivery reconciliation (delivery-ETA worker). Country is fixed per
      // storefront; transitUrl blank => the check is disabled and nothing shows.
      var deliveryNote = root.querySelector('[data-sl-delivery-note]');
      var deliveryNoteHeading = root.querySelector('[data-sl-delivery-note-heading]');
      var deliveryNoteBody = root.querySelector('[data-sl-delivery-note-body]');
      var noNearbyLocation = root.querySelector('[data-sl-no-nearby-location]');
      var transitUrl = (drawer.getAttribute('data-transit-url') || '').replace(/\/$/, '');
      var country = (drawer.getAttribute('data-country') || 'AU').toUpperCase();

      /* Runs fn once the shared ETA module (assets/delivery-eta.js) is on the
         page. This block's script is compiled into block-scripts.js, a deferred
         script in the head; the module is a deferred script in the body, so it
         always executes AFTER this one. That was fine while the worker lookups
         took a network round trip, because the module had landed by the time a
         response came back. It is not fine when the browser answers those
         lookups from its HTTP cache (the worker allows an hour): a customer who
         has visited any product page with the same postcode and store gets the
         responses in a few milliseconds, the callbacks below ran before the
         module existed, and every ETA path returned silently - "Standard
         delivery: TBC" and "Ready for pickup: TBC" until a reload, which
         revalidates the cache and so is slow enough to work (Daniel, 2 Sep
         2026). Waiting on the module's own script load event, with window load
         as the backstop, closes that gap; if the module never arrives nothing
         runs, exactly as before. */
      var etaWaiters = [];
      function whenETA(fn) {
        if (window.ESDeliveryETA) { fn(); return; }
        etaWaiters.push(fn);
        if (etaWaiters.length > 1) { return; }
        var fired = false;
        function flush() {
          if (fired || !window.ESDeliveryETA) { return; }
          fired = true;
          var queued = etaWaiters;
          etaWaiters = [];
          queued.forEach(function (f) { f(); });
        }
        Array.prototype.forEach.call(document.querySelectorAll('script[src*="delivery-eta"]'), function (el) {
          el.addEventListener('load', flush);
        });
        window.addEventListener('load', flush, { once: true });
      }
      // postcode lookup cache (keyed by country|postcode), holds the fetch promise.
      var transitCache = {};

      // Pickup line (Ready for pickup). IN STOCK comes from the esr stock
      // metafield rendered onto the root, NOT Shopify inventory. Stores that
      // can't accept the product at all carry data-excluded (server-rendered
      // from the store's exclusions field) and short-circuit the whole line.
      var pickupDot = root.querySelector('[data-sl-pickup-dot]');
      var pickupText = root.querySelector('[data-sl-pickup-text]');
      // Standard-delivery line (Delivery to {postcode}).
      var deliveryLineDot = root.querySelector('[data-sl-delivery-dot]');
      var deliveryLineText = root.querySelector('[data-sl-delivery-text]');
      // Merchant wording, carried on the element the JS overwrites. The
      // shipping estimate's label rides in the data-sl-shipping JSON because
      // that is the config its own feature already parses; this line has no
      // such element (it renders whether or not the estimate is switched on),
      // so it travels on the span itself. Either way the value is data, never
      // source: Liquid is not rendered inside the javascript tag.
      var deliveryLabel = deliveryLineText
        ? deliveryLineText.getAttribute('data-sl-delivery-label') || 'Standard delivery'
        : 'Standard delivery';
      var costLine = root.querySelector('[data-sl-cost]');
      var costInfo = root.querySelector('[data-sl-cost-info]');
      /* The modal is rendered outside `root` (it is a sibling dialog), so it is
         looked up on the document like the other dialogs in this file. */
      var costRates = document.querySelector('[data-sl-cost-rates]');
      var shipModal = document.querySelector('[data-sl-ship-modal]');

      /* Open and close, following the house prompt rather than the shared
         drawer controller - that controller only acts on `dialog.drawer`, and
         those classes carry the drawer's tall geometry with them. Escape and a
         backdrop click are native to <dialog>; only the X and the backdrop need
         wiring. Scroll is locked while open, as the drawer controller does. */
      if (shipModal) {
        shipModal.addEventListener('click', function (e) {
          // A click on the dialog itself is the backdrop - the panel swallows
          // clicks that land on the panel.
          if (e.target === shipModal || (e.target.closest && e.target.closest('[data-sl-ship-close]'))) {
            shipModal.close();
          }
        });
        shipModal.addEventListener('close', function () {
          document.documentElement.style.overflow = '';
          if (costInfo && typeof costInfo.focus === 'function') { costInfo.focus(); }
        });
      }
      if (costInfo) {
        costInfo.addEventListener('click', function () {
          if (!shipModal || typeof shipModal.showModal !== 'function' || shipModal.open) { return; }
          var current = document.querySelector('dialog[open]');
          if (current && current !== shipModal) { try { current.close(); } catch (err) {} }
          document.documentElement.style.overflow = 'hidden';
          shipModal.showModal();
        });
      }
      var stockAvailable = parseInt(root.getAttribute('data-stock-available'), 10) || 0;
      var stockOnOrder = parseInt(root.getAttribute('data-stock-on-order'), 10) || 0;
      var arrivingSoonLabel = root.getAttribute('data-arriving-soon') || 'Arriving soon';
      var etaTs = parseInt(root.getAttribute('data-eta'), 10) || 0;
      // Pre-order products ship when their incoming order arrives, so the ETA
      // drives the delivery/pickup date maths even while stock_available > 0.
      var isPreorder = root.hasAttribute('data-preorder');
      // In-store-only: no delivery and no collection (CSS hides the delivery
      // card), so the CTA prompts for a store on in-store availability instead.
      var isInstoreOnly = root.hasAttribute('data-instore-only');
      // outlet collection-profile cache (keyed by outlet id), holds the fetch promise.
      var collectionCache = {};

      /* ----- In-store availability ("On display") ----------------------------
         Rex product id and product group for the in-store line. The group is the
         display tag: with it the product is Display Stock, without it Cash &
         Carry. Clearance is not a third branch - those items have the tag removed
         upstream, so they arrive here as Cash & Carry already. */
      var rexProductId = (root.getAttribute('data-rex-product') || '').trim();
      // Cache tier for the worker ('long'/'short') - decided in Liquid, where
      // the tags are; the worker only maps tier to TTL and defaults to 'short'.
      var stockTier = (root.getAttribute('data-stock-tier') || '').trim();
      var isDisplayStock = root.hasAttribute('data-fis-display-only');
      var displayUnavailable = 'Inventory not available, please contact the store';
      /* Warehouses (#1173). Nobody can browse one, so the in-store line is this
         one string regardless of stock, and the collection label drops the word
         "Store". A display-stock product with no stock lands on the same state.
         Kept in step with sl_not_on_display in the Liquid above. */
      var notOnDisplayText = 'Not on Display - Available to Order';
      // Resolves to the worker's per-store map, or null. One request per page.
      var stockPromise = null;

      /* ----- Native bundle components (#961) ---------------------------------
         A bundle parent carries none of the stock/ETA/Rex data above - it has no
         Rex SKU - so every line below would read "Unavailable". Its components
         do carry it, and the bundle can only be as ready as its slowest part, so
         the lines answer on the worst case across them.

         Two hops, deliberately: WHICH products a bundle contains is only
         available from the Storefront API (Liquid cannot see them), while the
         numbers for each of those products are read back through the theme's own
         Liquid (sections/bundle-component-data.liquid). That keeps the effective
         ETA, the Rex id and its blob fallback identical to the ordinary product
         path - `esr.rex_productid` is not storefront-readable, so the API could
         not answer for it anyway. */
      var isBundle = root.hasAttribute('data-bundle');
      var isMM = root.hasAttribute('data-mm-master');
      /* Both kinds of parent price and stock from their COMPONENTS rather than
         from themselves - neither carries a Rex SKU. Named, because every place
         that has to choose between "this product" and "its components" must ask
         the same question: gating one of them on isBundle alone is exactly how
         the in-store row came to fall back to the master's missing Rex id. */
      var hasComponentBreakdown = isBundle || isMM;
      var productHandle = root.getAttribute('data-product-handle') || '';
      // Read at call time, not at init: the theme editor re-renders the block
      // when the setting changes, and the first calculation can run before that.
      function sfapiToken() { return (root.getAttribute('data-sfapi-token') || '').trim(); }
      var componentsPromise = null;

      function shopRoot() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      }

      function parseComponentData(html) {
        if (!html) { return null; }
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var el = tmp.querySelector('[data-bundle-component]');
        if (!el) { return null; }
        return {
          handle: el.getAttribute('data-handle') || '',
          title: el.getAttribute('data-title') || '',
          // Short label for the in-store lines, falling back to the full title.
          label: el.getAttribute('data-label') || el.getAttribute('data-title') || '',
          url: el.getAttribute('data-url') || '',
          stockAvailable: parseInt(el.getAttribute('data-stock-available'), 10) || 0,
          stockOnOrder: parseInt(el.getAttribute('data-stock-on-order'), 10) || 0,
          etaTs: parseInt(el.getAttribute('data-eta'), 10) || 0,
          rexProductId: (el.getAttribute('data-rex-product') || '').trim(),
          stockTier: (el.getAttribute('data-stock-tier') || '').trim(),
          isPreorder: el.hasAttribute('data-preorder'),
          isDisplayStock: el.hasAttribute('data-fis-display-only')
        };
      }

      /* The bundle's components with their delivery inputs, in the Bundles app's
         own order. Resolves to null for an ordinary product, a missing token, or
         any failure - every caller then falls back to the parent-product path,
         which is the existing behaviour. One request per page. */
      /* The Mix & Match selection, in the buy box's own component order. Read
         from the DOM on demand rather than cached, so it is always the CURRENT
         pair - the shopper can swap either side at any time. */
      function mmSelectedHandles() {
        var inputs = document.querySelectorAll('.mix-match__option-input:checked');
        var out = [];
        for (var i = 0; i < inputs.length; i++) {
          var h = inputs[i].value;
          if (h && out.indexOf(h) === -1) { out.push(h); }
        }
        return out;
      }

      /* One component record per handle, through the SAME section render the
         native-bundle path uses - so the effective ETA, the Rex id and its blob
         fallback are computed identically for every product in the theme. */
      function fetchComponentData(handles) {
        var base = shopRoot();
        return Promise.all(handles.map(function (h) {
          return fetch(base + 'products/' + encodeURIComponent(h) + '?section_id=bundle-component-data')
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(parseComponentData)
            .catch(function () { return null; });
        })).then(function (list) {
          var found = list.filter(Boolean);
          return found.length ? found : null;
        });
      }

      function loadComponents() {
        if (componentsPromise) { return componentsPromise; }

        /* Mix & Match: no discovery hop needed. The two selected handles are in
           the DOM, so go straight to the per-component data and let every
           downstream line aggregate exactly as it does for a bundle. */
        if (isMM) {
          var mmHandles = mmSelectedHandles();
          if (!mmHandles.length) {
            componentsPromise = Promise.resolve(null);
            return componentsPromise;
          }
          componentsPromise = fetchComponentData(mmHandles).catch(function () { return null; });
          return componentsPromise;
        }

        var token = sfapiToken();
        if (!isBundle || !token || !productHandle) {
          componentsPromise = Promise.resolve(null);
          return componentsPromise;
        }
        var query = 'query BundleComponents($handle: String!) {' +
          ' product(handle: $handle) { variants(first: 1) { nodes {' +
          ' components(first: 30) { nodes { productVariant { product { handle } } } }' +
          ' } } } }';
        componentsPromise = fetch(location.origin + '/api/2026-04/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
          body: JSON.stringify({ query: query, variables: { handle: productHandle } })
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (res) {
            var variant = res && res.data && res.data.product && res.data.product.variants.nodes[0];
            var nodes = (variant && variant.components.nodes) || [];
            var handles = nodes.map(function (n) { return n.productVariant.product.handle; });
            handles = handles.filter(function (h, i) { return h && handles.indexOf(h) === i; });
            if (!handles.length) { return null; }
            return fetchComponentData(handles).then(function (found) {
              if (!found) { return null; }
              console.log('[store-locator] Bundle components for ' + productHandle + '\n' +
                found.map(function (c, i) {
                  return '  ' + (i + 1) + '. ' + c.title +
                    '  (stock ' + c.stockAvailable +
                    ', eta ' + (c.etaTs ? new Date(c.etaTs * 1000).toDateString() : 'none') +
                    ', rex ' + (c.rexProductId || 'none') + ')';
                }).join('\n'));
              return found;
            });
          })
          .catch(function () { return null; });
        return componentsPromise;
      }

      /* The delivery inputs each line computes against: one entry for an ordinary
         product, one per component for a bundle. */
      function optsList(components) {
        if (components && components.length) {
          return components.map(function (c) {
            return { title: c.title, opts: { stockAvailable: c.stockAvailable, stockOnOrder: c.stockOnOrder, etaTs: c.etaTs, isPreorder: c.isPreorder } };
          });
        }
        return [{ title: null, opts: { stockAvailable: stockAvailable, stockOnOrder: stockOnOrder, etaTs: etaTs, isPreorder: isPreorder } }];
      }

      /* The wording for the no-date state, shared by the three lines that can
         reach it. There is no honest date either way - what differs is whether
         anything is coming: a shipment still on order but held past its ETA
         reads "Arriving soon", and a product with nothing on order keeps
         "Unavailable". A bundle counts as arriving if ANY part is on order,
         because that part is what the whole is waiting on. */
      function noDateText(entries) {
        var onOrder = (entries || []).some(function (entry) {
          return ((entry.opts && entry.opts.stockOnOrder) || 0) > 0;
        });
        return onOrder ? arrivingSoonLabel : 'Unavailable';
      }

      /* The client's Stock in Store rules master file, as a pure function.
         `available` null means Rex could not answer for this store.

         Dots follow the theme's existing three, not the rules file's cell
         shading: green in stock, amber low, grey not available. The rules file
         shades its "not available" rows red, but every other dot on this page and
         on the product page uses grey for not-orderable (see
         docs/03-scoping/product-availability-states.md), and introducing a fourth
         colour here alone would make the locator disagree with the rest of the
         PDP. One line to change if the client wants red. */
      function fisState(available, displayStock, isWarehouse) {
        /* Ahead of the no-answer check on purpose (#1173). The warehouse line is
           not a statement about stock - it says the shopper cannot come and look
           at the item, which is true whether or not Rex answered for the outlet
           and whichever product group it is in. */
        if (isWarehouse) {
          return { text: notOnDisplayText, dot: '' };
        }
        if (available === null || available === undefined || isNaN(available)) {
          return { text: displayUnavailable, dot: '' };
        }
        if (displayStock) {
          return available >= 1
            ? { text: 'On Display - Call Store to Confirm', dot: 'sl-dot--success' }
            : { text: notOnDisplayText, dot: '' };
        }
        if (available >= 3) return { text: 'In Stock - Call Store to Confirm', dot: 'sl-dot--success' };
        if (available >= 1) return { text: 'Low Stock - Call Store to Confirm', dot: 'sl-dot--warning' };
        return { text: 'Not Available In-Store', dot: '' };
      }

      /* Every store's stock for this product, in one request. The worker owns the
         store-to-outlet matching (id first, name as a fallback for staging), so
         the whole store list goes with the request and comes back keyed by the
         outlet id these rows already carry. Resolves to null on any failure,
         which renders as unavailable rather than a wrong state. */
      function lookupStock() {
        if (stockPromise) { return stockPromise; }
        stockPromise = lookupStockFor(rexProductId, stockTier);
        return stockPromise;
      }

      /* One product's stock across every store. Split out of lookupStock() so a
         bundle can ask the same question per component - each has its own Rex
         product id, and the worker answers for one product at a time. */
      function lookupStockFor(productId, tier) {
        if (!transitUrl || !productId || !stores.length) {
          return Promise.resolve(null);
        }
        var payload = {
          productId: productId,
          tier: tier || '',
          stores: stores.map(function (s) {
            return {
              outletId: s.getAttribute('data-outlet') || '',
              name: s.getAttribute('data-name') || '',
              state: s.getAttribute('data-state') || '',
              country: s.getAttribute('data-country') || ''
            };
          }).filter(function (s) { return !!s.outletId; })
        };
        return fetch(transitUrl + '/stock', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (body) { return (body && body.resolved) || null; })
          .catch(function () { return null; });
      }

      /* Applies the messages: the selected store's inline row, and every row in
         the all-stores drawer. Safe to call before a store is chosen - the inline
         row is hidden then, and the drawer rows still fill in. */
      /* A bundle's in-store line is one row per component - a shopper needs to
         know which half of the set is on the floor, and the two can differ
         (Figma: "... on display" / "... not on display"). Each component is a
         separate Rex product, so this is one lookup each, run once and reused by
         both the inline row and every drawer row. */
      var bundleDisplayPromise = null;
      function loadBundleDisplay() {
        if (bundleDisplayPromise) { return bundleDisplayPromise; }
        bundleDisplayPromise = loadComponents().then(function (components) {
          if (!components || !components.length) { return null; }
          return Promise.all(components.map(function (c) {
            return lookupStockFor(c.rexProductId, c.stockTier).then(function (resolved) {
              return { component: c, resolved: resolved };
            });
          }));
        }).catch(function () { return null; });
        return bundleDisplayPromise;
      }

      /* Rewrites a display row as one line per component. The row's own dot and
         text are reused for the first component so an ordinary product is
         untouched, and the extra lines are appended after it. */
      function paintBundleRows(row, outletId, entries, isWarehouse) {
        if (!row) { return; }
        var host = row.parentNode;
        if (!host) { return; }
        var extras = host.querySelectorAll('[data-sl-bundle-line]');
        for (var i = 0; i < extras.length; i++) { extras[i].parentNode.removeChild(extras[i]); }
        var after = row;
        entries.forEach(function (entry, index) {
          var hit = entry.resolved ? entry.resolved[outletId] : null;
          var state = fisState(hit ? hit.available : null, entry.component.isDisplayStock, isWarehouse);
          var text = (entry.component.label || entry.component.title) + ' ' + state.text.toLowerCase();
          var target = row;
          if (index > 0) {
            target = row.cloneNode(true);
            target.setAttribute('data-sl-bundle-line', '');
            /* The first line keeps the row's own top margin, which separates the
               group from the line above it; the lines after it sit on the list's
               own rhythm instead of repeating that separation between every
               component. Set here rather than in the stylesheet because the
               margin the clone inherits is not from a rule this block owns. */
            target.style.marginBlockStart = '0px';
            after.parentNode.insertBefore(target, after.nextSibling);
            after = target;
          }
          var textEl = target.querySelector('[data-sl-store-display-text], [data-sl-display-text]');
          var dotEl = target.querySelector('[data-sl-store-display-dot], [data-sl-display-dot]');
          if (textEl) { textEl.textContent = text; }
          if (dotEl) { dotEl.className = 'sl-dot' + (state.dot ? ' ' + state.dot : ''); }
        });
      }

      function updateOnDisplay() {
        /* LAZY (Rex 100k/day limit, 22 Sep 2026): the lookup only runs for an
           ENGAGED shopper - a saved store or postcode, or the drawer open. For
           anyone else everything this paints sits inside the closed drawer
           (the inline row needs st.name, the too-far banner needs a location),
           so skipping costs nothing visible and cuts the request count itself
           - /stock used to fire on every PDP view, ~90k on a peak Saturday.
           The drawer's toggle listener re-runs this on first open (the same
           lazy pattern the maps use), and lookupStock()/loadBundleDisplay()
           memoise their promise, so re-entry never duplicates a request. */
        var gate = loadState();
        if (!gate.name && !gate.postcode && !(drawer && drawer.open)) { return; }
        if (hasComponentBreakdown) {
          loadBundleDisplay().then(function (entries) {
            if (!entries || !entries.length) { return; }
            console.log('[store-locator] Bundle in-store availability\n' +
              entries.map(function (e) {
                return '     - ' + e.component.title + ': ' + (e.resolved ? 'Rex answered' : 'no Rex data') +
                  (e.component.rexProductId ? '  (rex ' + e.component.rexProductId + ')' : '  (no rex product id)');
              }).join('\n'));
            stores.forEach(function (st2) {
              paintBundleRows(st2.querySelector('[data-sl-store-display-row]'), st2.getAttribute('data-outlet') || '', entries, isWarehouseEl(st2));
            });
            var stSel = loadState();
            /* Keyed on the saved NAME rather than the outlet id, so a warehouse
               still gets its line when the saved state predates outlet ids: the
               wording does not need the id, and stockFor('') simply misses. */
            if (stSel && stSel.name) {
              var selWarehouse = isWarehouseEl(storeElFor(stSel));
              var rows = root.querySelectorAll('[data-sl-display-row]:not([data-sl-bundle-line])');
              for (var i = 0; i < rows.length; i++) { paintBundleRows(rows[i], stSel.outlet || '', entries, selWarehouse); }
            }
          });
          return;
        }
        lookupStock().then(function (resolved) {
          function stockFor(outletId) {
            if (!resolved) { return null; }
            var hit = resolved[outletId];
            return hit ? hit.available : null;
          }
          function paint(row, outletId, isWarehouse) {
            if (!row) { return; }
            var textEl = row.querySelector('[data-sl-store-display-text], [data-sl-display-text]');
            var dotEl = row.querySelector('[data-sl-store-display-dot], [data-sl-display-dot]');
            var state = fisState(stockFor(outletId), isDisplayStock, isWarehouse);
            if (textEl) { textEl.textContent = state.text; }
            if (dotEl) { dotEl.className = 'sl-dot' + (state.dot ? ' ' + state.dot : ''); }
          }

          // Drawer: one row per store.
          stores.forEach(function (s) {
            paint(s.querySelector('[data-sl-store-display-row]'), s.getAttribute('data-outlet') || '', isWarehouseEl(s));
          });

          toofarStock = resolved;
          reconcileTooFar();

          // Inline: the selected store only.
          /* Same widening as the bundle branch: a store being chosen is enough
             to paint, because a warehouse answers without an outlet id. For
             every other store stockFor('') misses and the row is painted with
             the unavailable text it was already showing. */
          var st = loadState();
          if (st && st.name) {
            var stWarehouse = isWarehouseEl(storeElFor(st));
            var rows = root.querySelectorAll('[data-sl-display-row]');
            for (var i = 0; i < rows.length; i++) { paint(rows[i], st.outlet || '', stWarehouse); }
          }
        });
      }

      // ----- Per-store: render hours table + live open status -----
      stores.forEach(function (store) {
        var tz = store.getAttribute('data-tz') || 'Australia/Sydney';
        var now = nowInTz(tz);

        // Reformat the static hours rows to "9am-5:30pm". Skipped entirely when
        // the store has no hours on record - Liquid has already hidden the block,
        // and writing 'Closed' into it would claim knowledge we do not have.
        if (hasAnyHours(store)) {
          var dds = store.querySelectorAll('[data-sl-hours-day]');
          dds.forEach(function (dd) {
            var raw = store.getAttribute('data-hours-' + dd.getAttribute('data-sl-hours-day'));
            var r = parseRange(raw);
            dd.textContent = r ? r.label : 'Closed';
          });
        }

        // Today's status line + "Open now" pill.
        var statusEl = store.querySelector('[data-sl-openstatus]');
        var openNowEl = store.querySelector('[data-sl-opennow]');
        if (now && now.dayIndex >= 0) {
          var todayRaw = store.getAttribute('data-hours-' + DAYS[now.dayIndex]);
          var today = parseRange(todayRaw);
          if (today && now.minutes >= today.open && now.minutes < today.close) {
            if (statusEl) { statusEl.textContent = 'Open ' + today.label + ' today'; }
            if (openNowEl) { openNowEl.textContent = 'Open now'; }
          } else if (today && now.minutes < today.open) {
            if (statusEl) { statusEl.textContent = 'Opens ' + fmtTime(todayRaw.split('-')[0].trim()) + ' today'; }
          } else if (hasAnyHours(store)) {
            // Genuinely shut right now - we hold this store's hours and they say so.
            if (statusEl) {
              statusEl.textContent = 'Closed';
              statusEl.classList.remove('sl-status--open');
              statusEl.classList.add('sl-status--tbc');
            }
          }
        }
      });

      // ----- Accordion (Store details) toggle - animates max-height -----
      function expandDetails(el) {
        el.style.maxHeight = el.scrollHeight + 'px';
        var done = function (ev) {
          if (ev && ev.propertyName !== 'max-height') { return; }
          el.style.maxHeight = 'none';
          el.removeEventListener('transitionend', done);
        };
        el.addEventListener('transitionend', done);
      }
      function collapseDetails(el) {
        el.style.maxHeight = el.scrollHeight + 'px';
        el.offsetHeight; // force reflow so the change to 0 transitions
        el.style.maxHeight = '0px';
      }
      function setToggleState(store, isOpen) {
        var toggle = store.querySelector('[data-sl-toggle]');
        var details = store.querySelector('[data-sl-details]');
        var label = store.querySelector('[data-sl-toggle-label]');
        if (toggle) { toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false'); }
        if (label) { label.textContent = isOpen ? 'Hide store details' : 'Store details'; }
        if (details) { if (isOpen) { expandDetails(details); } else { collapseDetails(details); } }
      }

      function zoomToStore(index) {
        if (!map) { return; }
        for (var i = 0; i < gMarkers.length; i++) {
          if (String(gMarkers[i].index) === String(index)) {
            map.panTo(gMarkers[i].marker.getPosition());
            map.setZoom(12);
            break;
          }
        }
      }

      // Open one store's details: close any other open accordion first (only one
      // at a time), then zoom the map to this store's pin.
      function openStore(store) {
        var thisToggle = store.querySelector('[data-sl-toggle]');
        var alreadyOpen = thisToggle && thisToggle.getAttribute('aria-expanded') === 'true';
        var openToggle = drawer.querySelector('[data-sl-toggle][aria-expanded="true"]');
        if (openToggle) {
          var openS = openToggle.closest('[data-sl-store]');
          if (openS && openS !== store) { setToggleState(openS, false); }
        }
        if (!alreadyOpen) { setToggleState(store, true); }
        zoomToStore(store.getAttribute('data-index'));
      }

      function closeStore(store) {
        setToggleState(store, false);
      }

      drawer.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-sl-toggle]');
        if (!toggle) { return; }
        var store = toggle.closest('[data-sl-store]');
        if (toggle.getAttribute('aria-expanded') === 'true') { closeStore(store); }
        else { openStore(store); }
      });

      // ----- My store (persisted) -----
      // Persisted state: postcode and chosen store are INDEPENDENT - either,
      // both, or neither may be set.
      function loadState() {
        try { return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {}; }
        catch (e) { return {}; }
      }
      function saveState(st) {
        try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(st)); } catch (e) {}
      }
      /* The row in the drawer that the saved store came from. The saved state
         carries a name, an index and (since the cart page needed it) an outlet
         id, but nothing about the store itself - so anything that has to know
         what KIND of store was chosen has to come back to the DOM for it.

         Outlet first because it survives the list being reordered or a store
         being added; the index is the fallback for a state saved before outlet
         ids were persisted. */
      function storeElFor(st) {
        if (!st) { return null; }
        var i;
        if (st.outlet) {
          for (i = 0; i < stores.length; i++) {
            if ((stores[i].getAttribute('data-outlet') || '') === st.outlet) { return stores[i]; }
          }
        }
        if (st.index !== null && st.index !== undefined) {
          for (i = 0; i < stores.length; i++) {
            if (stores[i].getAttribute('data-index') === String(st.index)) { return stores[i]; }
          }
        }
        return null;
      }
      function isWarehouseEl(el) {
        return !!(el && el.getAttribute('data-warehouse') === 'true');
      }
      /* Hide delivery to store (#1256): the merchant has said this store is not
         taking collection orders (today, a store listed before it opens). Read
         off the server-rendered attribute, like the exclusion, so it holds
         with the worker down and beats any lead time the sheet may carry. */
      function isCollectHiddenEl(el) {
        return !!(el && el.hasAttribute('data-collect-hidden'));
      }

      // The outlet id is persisted alongside the index because `index` only
      // means anything against this list in this DOM - the cart page needs the
      // outlet itself to look up collection lead times.
      function setStore(index, name, outlet) {
        var st = loadState();
        st.index = index;
        st.name = name;
        if (outlet) { st.outlet = outlet; } else { delete st.outlet; }
        saveState(st);
      }
      function clearStore() {
        var st = loadState();
        delete st.index;
        delete st.name;
        delete st.outlet;
        saveState(st);
      }
      // `pc` is the postcode used for the deliverability lookup (from the place,
      // or reverse-geocoded). 'label' is the name shown in messages - the suburb
      // (#19498861). It used to be stored only when the place had no postcode of
      // its own, which is why the row read "Delivery to 3008" for a postcode
      // search and a full address for anything else; it is now always set, so
      // the wording is the same whichever way the location was given. 'suburb'
      // narrows the transit lookup within the postcode; absent, the worker
      // answers with the postcode's worst case.
      //
      // Falling back to 'suburb' covers the geolocation path, which has no
      // prediction to read a name from and only knows what the reverse geocode
      // returned.
      function setLocationState(pc, label, suburb) {
        var st = loadState();
        st.postcode = pc;
        var display = label || suburb;
        if (display) { st.label = display; } else { delete st.label; }
        if (suburb) { st.suburb = suburb; } else { delete st.suburb; }
        saveState(st);
      }
      /* The point the list and map are currently centred on. Persisted so the
         drawer opens where the shopper left off rather than zoomed out over the
         whole country (#19498854). Shared with the store locator page, so a
         search on either surface frames both. */
      function savePoint(lat, lng) {
        var st = loadState();
        st.lat = lat;
        st.lng = lng;
        saveState(st);
      }
      function clearPoint() {
        var st = loadState();
        delete st.lat;
        delete st.lng;
        saveState(st);
      }

      function clearPostcode() {
        var st = loadState();
        delete st.postcode;
        delete st.label;
        delete st.suburb;
        saveState(st);
      }

      /* CTA wording names whichever half is still missing, so the button says
         what pressing it will get you (#19500365). Four states:
           neither set        -> confirm (the inline panel is the one showing)
           location, no store -> set a store
           store, no location -> confirm the location
           both set           -> change
         In-store-only products have neither delivery nor collection - CSS hides
         the whole delivery card - so their store is only worth setting for
         in-store availability, and it gets its own wording. Online-only keeps
         the collection wording: that flag drops the "on display" line only
         (client direction 2026-07-23), collection still applies. */
      function ctaLabel(hasPostcode, hasStore) {
        if (isInstoreOnly) {
          return hasStore ? 'Change location' : 'Set your store to view in-store availability';
        }
        if (hasPostcode && hasStore) { return 'Change location'; }
        if (hasPostcode) { return 'Set your store to view collection options'; }
        return 'Confirm location to view delivery details';
      }

      /* Show a row in its filled or its prompt state. The row itself stays put
         either way; only the label form, the status line and the prompt swap. */
      function setRowState(row, filled, labelSet, labelEmpty, status, prompt) {
        if (!row) { return; }
        row.hidden = false;
        if (labelSet) { labelSet.hidden = !filled; }
        if (labelEmpty) { labelEmpty.hidden = filled; }
        if (status) { status.hidden = !filled; }
        if (prompt) { prompt.hidden = filled; }
      }

      function renderInlineState() {
        var st = loadState();
        var hasPostcode = !!st.postcode;
        // Priced from the saved postcode, so it follows every location change.
        updateShippingCost();
        var hasStore = !!st.name;
        var ctaText = ctaLabel(hasPostcode, hasStore);
        for (var ci = 0; ci < changeLocationLabels.length; ci++) {
          changeLocationLabels[ci].textContent = ctaText;
        }
        /* Online-only banner (#996). Daniel saw both this and the store
           section's "Online only items are not available to view in store" at
           once - the same statement twice - so the banner steps aside exactly
           when the other one appears.

           Keyed on hasStore, NOT on a location alone, because the store row is
           what carries the other message (`storeRows[..].hidden = !hasStore`
           below is the same condition). Hiding the banner any earlier would
           leave a shopper who has entered a location but not set a store with
           no online-only messaging at all.

           Set OUTSIDE the state branch below, so clearing a saved store puts
           the banner back rather than leaving it stuck hidden - the else branch
           does not touch it. */
        if (onlineOnly) { onlineOnly.hidden = hasStore; }
        /* Straight swap between the two states now. This used to force the
           selected panel for every online-only product, chosen or not, because
           that panel carried the "available online only" message - which meant
           clearing a saved location left the shopper with the message, a button,
           and no heading, intro or field to enter a location with (#19498854).
           The message is its own element above the block, so neither state has
           to be held open to carry it. */
        if (hasPostcode || hasStore) {
          if (inline) { inline.hidden = true; }
          if (selected) { selected.hidden = false; }
          if (hasPostcode && selectedPostcode) { selectedPostcode.textContent = st.label || st.postcode; }
          if (hasStore) {
            for (var ni = 0; ni < selectedNames.length; ni++) { selectedNames[ni].textContent = st.name; }
            /* "Delivery to Auckland Warehouse Store" (#1173). Warehouses carry
               what they are in their name already, so the suffix goes; every
               other store keeps it, and it is restored rather than only removed
               so switching back off a warehouse puts it right. Driven by the
               same three-way flag as the availability line, so the two can
               never disagree about what a store is. */
            if (collectSuffix) {
              collectSuffix.textContent = isWarehouseEl(storeElFor(st)) ? '' : ' Store';
            }
          }
          setRowState(postcodeRow, hasPostcode, postcodeLabel, postcodeLabelEmpty, postcodeStatus, postcodePrompt);
          setRowState(collectRow, hasStore, collectLabel, collectLabelEmpty, collectStatus, collectPrompt);
          for (var si = 0; si < storeRows.length; si++) { storeRows[si].hidden = !hasStore; }
          if (delivery) { delivery.hidden = false; }
        } else {
          if (inline) { inline.hidden = false; }
          if (selected) { selected.hidden = true; }
        }
        reconcileDelivery();
        updatePickup();
        reconcileBulkyCallout();
        // Runs on first render and on every store/location change. The Rex request
        // itself is made once per page and reused - only the painting repeats.
        updateOnDisplay();
      }

      // Look up a store's collection profile (in-stock lead time + bulky
      // capability) via the worker. Resolves to the response object, or null
      // (disabled / network / non-OK). Cached per outlet.
      function lookupCollection(outletId) {
        if (!transitUrl || !outletId) { return Promise.resolve(null); }
        if (collectionCache[outletId]) { return collectionCache[outletId]; }
        var url = transitUrl + '/collection?outlet=' + encodeURIComponent(outletId) +
          '&country=' + encodeURIComponent(country);
        var p = fetch(url)
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
        collectionCache[outletId] = p;
        return p;
      }

      // A pickup window (warehouse-ready date + the store's collection lead
      // time) as customer copy. Precision follows the client's three lead-time
      // tiers, so a window months out reads as a month part rather than a
      // spuriously exact pair of dates:
      //   under ~4 weeks -> the min-max date range ("17 - 20 September")
      //   beyond ~4 weeks -> the month part of the LATER date ("Late September")
      //   beyond ~4 weeks -> the month part of the later date ("late August")
      // The exact dates are still logged either way (see logPickup).
      function fmtPickupWindow(win) {
        var ESD = window.ESDeliveryETA;
        if (!ESD) { return ''; }
        // Two tiers only - the season band was removed (#19498858), so the
        // month part covers everything beyond ~4 weeks.
        var tier = ESD.tierFor(win.max);
        if (tier === 'near') { return ESD.fmtRange(win.min, win.max); }
        return ESD.monthPart(win.max) + ' ' + ESD.monthName(win.max);
      }

      // ----- Standard delivery (Delivery to {postcode}) -----
      // Arrival = base date + picking, then the first dispatch day on/after
      // that, + transit days (the #1123 formula; see assets/delivery-eta.js).
      // The maths lives in assets/delivery-eta.js (shared with the cart page);
      // this function only decides what the row says and logs the working.
      //
      // The displayed value follows the client's three lead-time tiers, so the
      // promise gets less precise the further out it is:
      //   under ~4 weeks  -> "within 5 days"
      //   beyond ~4 weeks  -> "Late September"
      //   beyond ~4 weeks -> "late August"
      // The exact arrival date is still logged at step 5 below, so switching
      // back to showing a hard date is a one-line change.
      /* ---------------------------------------------------------------
         Shipping estimate (#1126).

         A faithful port of the 1.0 theme's Shipping Calculator. It is a lookup
         over merchant-maintained tables, NOT a rate API: no request is made and
         no cart is created, which is also why it can run on every render.

         The 1.0 rules, kept exactly:
           - the product's size is its `web_shipping_type:` tag
           - size matches the home-delivery tag -> a flat rate by postcode
           - otherwise -> a courier rate, postcode picking the region column and
             the size tag picking the row
           - the home-delivery tag reading "BLANK" is a sentinel meaning "quote
             home delivery for everything", which is how NZ is configured; a
             product then gets a home delivery rate AND a courier rate
           - a bare figure renders with cents ("110" -> "$110.00")

         The inline line shows the first rate, which is the home delivery one
         whenever there is one. Both go in the modal.
         --------------------------------------------------------------- */
      var shipCfg = null;
      (function () {
        var el = document.querySelector('[data-sl-shipping]');
        if (!el) { return; }
        try { shipCfg = JSON.parse(el.textContent); } catch (e) { shipCfg = null; }
      })();

      /* "225,2540,2787|200,2790" -> [{ rate: '225', postcodes: {2540:1, 2787:1} }] */
      function shipParseBands(raw) {
        var out = [];
        String(raw || '').split('|').forEach(function (line) {
          var parts = line.split(',');
          var rate = (parts.shift() || '').trim();
          if (!rate) { return; }
          var pcs = {};
          parts.forEach(function (pc) {
            pc = pc.trim();
            if (pc) { pcs[pc] = 1; }
          });
          out.push({ rate: rate, postcodes: pcs });
        });
        return out;
      }

      /* "small,20,25,35|large,45,60,70" -> [{ tag, metro, regional, outer }] */
      function shipParseCourier(raw) {
        var out = [];
        String(raw || '').split('|').forEach(function (line) {
          var p = line.split(',');
          if (!p[0] || !p[0].trim()) { return; }
          out.push({
            tag: p[0].trim().toLowerCase(),
            metro: (p[1] || '').trim(),
            regional: (p[2] || '').trim(),
            outer: (p[3] || '').trim()
          });
        });
        return out;
      }

      function shipParseList(raw) {
        var pcs = {};
        String(raw || '').split(',').forEach(function (pc) {
          pc = pc.trim();
          if (pc) { pcs[pc] = 1; }
        });
        return pcs;
      }

      /* Exact match first, then zero-padded to four. Excel strips leading zeros
         on export and NZ postcodes need theirs, the same trap the transit tables
         hit - so a re-exported rate table cannot silently stop matching. */
      function shipHas(map, pc) {
        if (map[pc]) { return true; }
        var padded = pc.length < 4 ? ('0000' + pc).slice(-4) : pc;
        return !!map[padded];
      }

      function shipMoney(value) {
        return value.indexOf('.') === -1 ? '$' + value + '.00' : '$' + value;
      }

      /* The comparable form of the same raw table cell shipMoney formats, so
         rates can be ordered by value (#20015672). Parsed from the TABLE cell,
         never from shipMoney's output: re-reading a formatted string would tie
         the comparison to the currency symbol and the decimal convention and
         break the moment either changes. A malformed cell yields NaN, which the
         caller treats as "cannot be compared" rather than as zero - zero would
         win every comparison and put a broken row on the inline line. */
      function shipAmount(value) {
        return parseFloat(value);
      }

      function shipHomeRate(pc) {
        var bands = shipParseBands(shipCfg.homeDeliveryRates);
        for (var i = 0; i < bands.length; i++) {
          if (shipHas(bands[i].postcodes, pc)) {
            return {
              description: 'Home Delivery',
              rate: shipMoney(bands[i].rate),
              amount: shipAmount(bands[i].rate)
            };
          }
        }
        return null;
      }

      function shipCourierRate(pc, size) {
        var groups = [
          { key: 'metro', map: shipParseList(shipCfg.metro) },
          { key: 'regional', map: shipParseList(shipCfg.regional) },
          { key: 'outer', map: shipParseList(shipCfg.outerRegional) }
        ];
        var band = null;
        for (var i = 0; i < groups.length; i++) {
          if (shipHas(groups[i].map, pc)) { band = groups[i].key; break; }
        }
        if (!band) { return null; }
        var rows = shipParseCourier(shipCfg.courierRates);
        for (var j = 0; j < rows.length; j++) {
          if (rows[j].tag === size.toLowerCase() && rows[j][band]) {
            return {
              description: 'Courier Delivery',
              rate: shipMoney(rows[j][band]),
              amount: shipAmount(rows[j][band])
            };
          }
        }
        return null;
      }

      /* Every rate that applies, home delivery first. Empty when there is no
         postcode, no table, no rate for that postcode, or no size tag on the
         product - all of which leave the line hidden rather than guessed at.

         This order is the MODAL's and is deliberately left alone. The inline
         figure no longer takes the first of these - it takes the cheapest, in
         updateShippingCost (#20015672). */
      function shipRatesFor(pc) {
        if (!shipCfg || !pc) { return []; }
        var out = [];
        var hdTag = String(shipCfg.homeDeliveryTag || '').toLowerCase();
        var size = String(shipCfg.size || '').trim();
        if (hdTag === 'blank') {
          var always = shipHomeRate(pc);
          if (always) { out.push(always); }
        }
        if (size) {
          if (hdTag && size.toLowerCase() === hdTag) {
            var home = shipHomeRate(pc);
            if (home) { out.push(home); }
          } else {
            var courier = shipCourierRate(pc, size);
            if (courier) { out.push(courier); }
          }
        }
        return out;
      }

      function updateShippingCost() {
        if (!costLine) { return; }
        var st = loadState();
        var pc = st.postcode ? String(st.postcode).trim() : '';
        var rates = shipRatesFor(pc);
        if (!rates.length) {
          costLine.textContent = '';
          costLine.hidden = true;
          if (costInfo) { costInfo.hidden = true; }
          return;
        }
        // Merchant wording, from the JSON config block (Liquid cannot reach in
        // here). Blank in the editor falls back in Liquid, so this is only a
        // guard for a missing/failed config parse.
        var costLabel = shipCfg && shipCfg.costLabel ? shipCfg.costLabel : 'Estimated delivery';
        /* The inline figure is the CHEAPEST rate, not the first (#20015672).
           Where the home-delivery tag is the "blank" sentinel - which is NZ, and
           means "quote home delivery for everything" - a product carries BOTH a
           home rate and its courier rate, and shipRatesFor pushes home first. So
           the inline line was showing home delivery every time regardless of
           price: a $15 ornament advertised $115 delivery to Auckland when the
           courier option for its size was $8.

           Chosen as "cheapest" rather than "prefer courier" so it stays correct
           if home delivery is ever the lower of the two, and so it needs no
           revisiting when a market has rates the other way round.

           NaN loses every comparison here, so a malformed table cell falls back
           to the first rate - the behaviour before this change - rather than
           blanking the line or printing a bad figure. */
        var cheapest = rates[0];
        for (var ri = 1; ri < rates.length; ri++) {
          if (
            isFinite(rates[ri].amount) &&
            (!isFinite(cheapest.amount) || rates[ri].amount < cheapest.amount)
          ) {
            cheapest = rates[ri];
          }
        }
        costLine.textContent = costLabel + ': ' + cheapest.rate;
        costLine.hidden = false;
        // The icon appears whenever a figure does: the checkout disclaimer
        // behind it applies to a single rate just as much as to two.
        if (costInfo) { costInfo.hidden = false; }
        if (costRates) {
          costRates.innerHTML = '';
          rates.forEach(function (r) {
            var dt = document.createElement('dt');
            dt.textContent = r.description;
            var dd = document.createElement('dd');
            dd.textContent = r.rate;
            costRates.appendChild(dt);
            costRates.appendChild(dd);
          });
        }
        // Show the working, matching the delivery and pickup QA logs.
        console.log(
          '[store-locator] Shipping estimate for ' + pc + '\n' +
          '  1. product size:   ' + (shipCfg.size || '(none on this product)') + '\n' +
          '  2. home-delivery tag: ' + shipCfg.homeDeliveryTag + '\n' +
          '  3. rates found:    ' + rates.map(function (r) { return r.description + ' ' + r.rate; }).join(', ') + '\n' +
          '  4. inline shows:   "' + costLabel + ': ' + cheapest.rate +
            '" (cheapest of ' + rates.length + ': ' + cheapest.description + ')'
        );
      }

      function updateDeliveryLine(transit) {
        if (!deliveryLineText || !transit || !transit.found) { return; }
        var ESD = window.ESDeliveryETA;
        if (!ESD) { whenETA(function () { updateDeliveryLine(transit); }); return; }
        // A bundle answers on its slowest component; everything else answers on
        // itself. loadComponents() resolves to null for both the ordinary case
        // and any failure, so this is the existing path untouched.
        loadComponents().then(function (components) {
          renderDeliveryLine(transit, components);
        });
      }

      /* The slowest component decides the bundle's arrival - it cannot be on the
         doorstep before its last part is. One unavailable component makes the
         whole bundle unavailable, and the log names it. */
      function worstArrival(transit, entries) {
        var ESD = window.ESDeliveryETA;
        var worst = null;
        var blocker = null;
        var rows = [];
        entries.forEach(function (entry) {
          var calc = ESD.homeArrival(entry.opts, transit);
          if (!calc) {
            if (!blocker) { blocker = entry; }
            rows.push('     - ' + (entry.title || 'this product') + ': ' + ESD.baseDate(entry.opts).why + ' -> unavailable');
            return;
          }
          rows.push('     - ' + (entry.title || 'this product') + ': ' +
            ESD.fmtCalcDay(calc.arrivalMin) + ' to ' + ESD.fmtCalcDay(calc.arrivalMax) + '  (' + calc.why + ')');
          // Compared on the late end - the bundle cannot land before its last part.
          if (!worst || calc.arrival.getTime() > worst.arrival.getTime()) { worst = calc; }
          // The bundle is only a confident promise when every part is.
          if (worst && !calc.confident) { worst.confident = false; }
        });
        return { calc: blocker ? null : worst, blocker: blocker, rows: rows };
      }

      function renderDeliveryLine(transit, components) {
        var ESD = window.ESDeliveryETA;
        if (!ESD) { return; }
        var entries = optsList(components);
        var isMulti = entries.length > 1;
        var picked = worstArrival(transit, entries);
        var opts = entries[0].opts;
        var calc = picked.calc;
        if (isMulti) {
          console.log('[store-locator] Bundle delivery calc for ' + transit.postcode + '\n' +
            '  1. per component (arrival, and why):\n' + picked.rows.join('\n') + '\n' +
            '  2. bundle takes the LAST arrival' +
            (picked.blocker ? '  -> "' + deliveryLabel + ': Unavailable" (' + picked.blocker.title + ' has no date)' : ''));
        }
        if (!calc) {
          if (!isMulti && ESD.baseDate(opts).date) { return; }
          // No stock and no usable ETA: the product is unavailable - there is
          // no start date to compute an arrival from. Grey dot, matching the
          // pickup line and the PDP "Currently unavailable" message.
          if (deliveryLineDot) { deliveryLineDot.classList.remove('sl-dot--success', 'sl-dot--warning'); }
          deliveryLineText.textContent = deliveryLabel + ': ' + noDateText(entries);
          return;
        }

        /* Dates rather than a day count since the Aug 17 postcode files gave us a
           min/max window (#1072): near shows "21 - 27 August" like the pickup
           line, beyond four weeks stays month parts, spanning them when the ends
           differ ("Late September - Early October"). The late end decides. */
        var msg = ESD.windowMessage(calc.arrivalMin, calc.arrivalMax);
        var label = msg.text;

        // Show the working for QA (per task #18517780). Keeps the exact dates
        // visible now the customer-facing copy is rounded to a tier.
        var tMin = transit.transitDaysMin != null ? transit.transitDaysMin : transit.transitDays;
        var tMax = transit.transitDaysMax != null ? transit.transitDaysMax : tMin;
        console.log(
          '[store-locator] Standard delivery calc for ' + transit.postcode +
          (transit.suburb ? ' (' + transit.suburb + ', matched on ' + transit.matchedOn + ')' : '') + '\n' +
          '  1. base date:      ' + ESD.fmtCalcDay(calc.base) + '  (' + calc.why + ')\n' +
          '  2. picking:        +' + calc.pickingDays + ' calendar days -> ' + ESD.fmtCalcDay(calc.picked) +
            (calc.pickingDays ? '  (picked, ready for a truck)' : '  (no picking time in this market\'s postcode file)') + '\n' +
          '  3. dispatch days:  ' + (transit.dispatchDays || []).join(', ') + '  (outlet ' + transit.outletId + ', to THIS postcode)\n' +
          '  4. next dispatch:  ' + ESD.fmtCalcDay(calc.dispatch) + '  (first dispatch day on/after picked)\n' +
          '  5. transit:        +' + tMin + ' to +' + tMax + ' days from dispatch\n' +
          '  6. arrival window: ' + ESD.fmtCalcDay(calc.arrivalMin) + '\n' +
          '                     to ' + ESD.fmtCalcDay(calc.arrivalMax) + '  (' + msg.days + ' days away at the late end)\n' +
          '  7. tier:           ' + msg.tier + ' (decided on the late end)  -> "' + deliveryLabel + ': ' + label + '"'
        );

        if (deliveryLineDot) {
          deliveryLineDot.classList.remove('sl-dot--success', 'sl-dot--warning');
          deliveryLineDot.classList.add(calc.confident ? 'sl-dot--success' : 'sl-dot--warning');
        }
        deliveryLineText.textContent = deliveryLabel + ': ' + label;
      }

      // Update the "Ready for pickup" line for the selected store:
      //   - store excluded for this product -> can't be sent there at all
      //   - pre-order with a usable ETA -> window from the ETA + the store lead
      //     time, amber dot - even while stock_available > 0
      //   - in stock (esr stock metafield, NOT Shopify inventory) -> window from
      //     today + the store lead time, green dot
      //   - out of stock with a usable warehouse ETA -> window from the ETA, amber
      //   - out of stock, no ETA -> "Unavailable", grey dot
      //   - no store / worker disabled or unreachable / no data -> leave as-is.
      // The window's precision follows the lead-time tiers (see
      // fmtPickupWindow); the exact dates stay in the console log.
      /* Does the CURRENTLY SELECTED store refuse this product? One definition,
         read by both the lift line inside the collect row and the callout under
         the block (#901), so the two can never disagree about the same store.

         No store chosen yet returns false: nothing has been judged, the collect
         row is still hidden, and the shopper has been told nothing to contradict. */
      function selectedStoreExcluded() {
        /* Resolved through storeElFor, so OUTLET first (#1173). This used to
           match on data-index alone, which silently judged the wrong store - or
           no store - once the list order changed beneath a saved selection. */
        var el = storeElFor(loadState());
        if (!el) { return false; }
        return el.hasAttribute('data-excluded');
      }

      /* The callout sits OUTSIDE the collect row, so it needs its own reconcile:
         updatePickup returns early when no store is chosen (and when the pickup
         elements are absent), and the callout still has to be right in those
         states. Called from renderInlineState, which runs on first render and on
         every store or location change. */
      function reconcileBulkyCallout() {
        if (!bulkyCallout) { return; }
        /* A hidden-collection store (#1256) is treated like an excluded one
           here: its pickup line reads Unavailable, so a lift message about
           collecting there would be talking over it in the same way. */
        var excluded = selectedStoreExcluded() || isCollectHiddenEl(storeElFor(loadState()));
        bulkyCallout.hidden = excluded;
        /* The --has-bulky modifier trades the block's own bottom margin for the
           24px gap up to the callout, on the understanding that the callout is
           carrying that margin instead. With the callout hidden nothing is
           carrying it, so the modifier has to come off too or the block ends on
           a 24px gap to whatever follows rather than its configured spacing. */
        root.classList.toggle('product__store-locator--has-bulky', !excluded);
      }

      function updatePickup() {
        if (!pickupDot && !pickupText) { return; }
        var st = loadState();
        /* #1173: resolve the saved store through storeElFor, which matches on
           OUTLET first and falls back to the index. This used to match on
           data-index alone and return early when it found nothing, leaving the
           server-rendered "Ready for pickup: TBC" placeholder on screen while
           the store NAME - resolved by outlet elsewhere - still read correctly.

           Any change to the store list breaks a saved index: adding Auckland
           Clearance Outlet to the NZ list put it at position 0 alphabetically
           and pushed every other store down one, so a shopper previously on
           Auckland Warehouse had an index landing on a store with no outlet id
           at all. Outlet ids do not move, so they cannot go stale this way. */
        var storeEl = storeElFor(st);
        if (!storeEl) { return; }
        var outletId = storeEl.getAttribute('data-outlet');
        var isExcluded = selectedStoreExcluded();
        var isHidden = isCollectHiddenEl(storeEl);
        // The exclusion is product + store data, both server-rendered, so it is
        // resolved before (and independently of) the lead-time lookup - the
        // message still shows when the worker is disabled or unreachable.
        // The two-person lift line follows the same judgement (#901): a store that
        // cannot take the item gets no lift message, because the pickup line is
        // already telling the shopper it cannot be collected there.
        var bulkyRow = root.querySelector('[data-sl-bulky-row]');
        if (bulkyRow) { bulkyRow.hidden = isExcluded || isHidden; }
        // Hide delivery to store (#1256) is judged first: it is about the store,
        // not this product, so it outranks the per-product exclusion message and
        // never waits on the worker. Same wording the no-date state uses, so the
        // line has one way of saying "not available" whatever the cause.
        if (isHidden) {
          var hiddenMsg = 'Ready for pickup: Unavailable';
          console.log('[store-locator] Ready for pickup calc for outlet ' + outletId + '\n' +
            '  1. state:          store has Hide delivery to store ticked (store_location metaobject)\n' +
            '  2. result:         -> "' + hiddenMsg + '"');
          setPickup('', hiddenMsg);
          return;
        }
        if (isExcluded) {
          var excludedMsg = 'Bulky items cannot be collected from this store';
          console.log('[store-locator] Ready for pickup calc for outlet ' + outletId + '\n' +
            '  1. state:          store excludes this product (store exclusions vs product tags)\n' +
            '  2. result:         -> "' + excludedMsg + '"');
          setPickup('', excludedMsg);
          return;
        }
        if (!outletId || !transitUrl) { return; }
        Promise.all([lookupCollection(outletId), loadComponents()]).then(function (both) {
          var data = both[0];
          var components = both[1];
          // The user may have switched store while the request was in flight.
          // Compared by outlet, for the same reason the lookup above is: an
          // index comparison also read equal for two states that both simply
          // had no index.
          var curEl = storeElFor(loadState());
          if (!curEl || curEl.getAttribute('data-outlet') !== outletId) { return; }
          if (!data || !data.found) { return; }
          var ESD = window.ESDeliveryETA;
          if (!ESD) { whenETA(updatePickup); return; }
          var entries = optsList(components);
          var isMulti = entries.length > 1;
          var opts = entries[0].opts;
          /* A bundle is ready for collection when its LAST part is, so both ends
             of the window take the later value across components. One component
             with no honest date makes the whole bundle unavailable. */
          var win = null;
          var blocker = null;
          var rows = [];
          entries.forEach(function (entry) {
            var w = ESD.collectionWindow(entry.opts, data);
            if (!w) {
              if (!blocker) { blocker = entry; }
              rows.push('     - ' + (entry.title || 'this product') + ': ' + ESD.baseDate(entry.opts).why + ' -> unavailable');
              return;
            }
            rows.push('     - ' + (entry.title || 'this product') + ': ' + ESD.fmtCalcDay(w.min) + ' to ' + ESD.fmtCalcDay(w.max) + '  (' + w.why + ')');
            if (!win) { win = w; return; }
            if (w.min.getTime() > win.min.getTime()) { win.min = w.min; }
            if (w.max.getTime() > win.max.getTime()) { win.max = w.max; win.base = w.base; win.why = w.why; }
            if (!w.confident) { win.confident = false; }
          });
          if (blocker) { win = null; }
          if (isMulti) {
            console.log('[store-locator] Bundle pickup calc for outlet ' + outletId + '\n' +
              '  1. per component (window, and why):\n' + rows.join('\n') + '\n' +
              '  2. bundle takes the LATER end of each' +
              (blocker ? '  -> "Ready for pickup: Unavailable" (' + blocker.title + ' has no date)' : ''));
          }
          if (!win) {
            // No stock and no usable ETA: the product is unavailable, so there
            // is no honest collection window to promise. Grey dot.
            var pickupNoDate = 'Ready for pickup: ' + noDateText(entries);
            console.log('[store-locator] Ready for pickup calc for outlet ' + outletId + '\n' +
              '  1. state:          ' + (blocker ? blocker.title + ': ' + ESD.baseDate(blocker.opts).why : ESD.baseDate(opts).why) + '\n' +
              '  2. result:         -> "' + pickupNoDate + '"');
            setPickup('', pickupNoDate);
            return;
          }
          var pickupLabel = 'Ready for pickup: ' + fmtPickupWindow(win);
          // Show the working for QA, mirroring the Standard delivery log. Exact
          // dates stay here even when the copy above is rounded to a tier.
          console.log('[store-locator] Ready for pickup calc for outlet ' + outletId + '\n' +
            '  1. state:          ' + win.why + '\n' +
            '  2. base date:      ' + ESD.fmtCalcDay(win.base) + '\n' +
            '  3. store lead time: +' + data.leadTimeMin + ' to +' + data.leadTimeMax + ' days\n' +
            '  4. window:         ' + ESD.fmtCalcDay(win.min) + ' to ' + ESD.fmtCalcDay(win.max) + '\n' +
            '  5. tier:           ' + ESD.tierFor(win.max) + '  -> "' + pickupLabel + '"');
          setPickup(win.confident ? 'success' : 'warning', pickupLabel);
        });
      }

      /* Every store's collection profile in one request, for the drawer. The
         single-outlet form backs the selected-store row; asking it 57 times on
         drawer open is not acceptable, and this table is static and edge-cached.
         Resolves to a map keyed by outlet id, or null. */
      var allCollectionsPromise = null;
      function lookupAllCollections() {
        if (allCollectionsPromise) { return allCollectionsPromise; }
        if (!transitUrl) {
          allCollectionsPromise = Promise.resolve(null);
          return allCollectionsPromise;
        }
        allCollectionsPromise = fetch(transitUrl + '/collection?country=' + encodeURIComponent(country))
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (body) { return (body && body.outlets) || null; })
          .catch(function () { return null; });
        return allCollectionsPromise;
      }

      /* Fills "Delivery to store" on every drawer row. Four outcomes, matching
         the selected-store row exactly:
           - store has Hide delivery to store ticked -> Unavailable (#1256)
           - store excludes this product -> the exclusion message
           - a usable base date          -> the collection window
           - neither                     -> Unavailable
         The first two are server-rendered per store, so they are honoured even
         when the worker is unreachable. NZ has no collection sheet yet, so every
         row there falls to Unavailable. */
      function updateStoreCollection() {
        if (!stores.length) { return; }
        var excludedMsg = 'Bulky items cannot be collected from this store';
        var hiddenMsg = 'Delivery to store: Unavailable';

        function paint(store, tone, text) {
          var row = store.querySelector('[data-sl-store-collect-row]');
          if (!row) { return; }
          var textEl = row.querySelector('[data-sl-store-collect-text]');
          var dotEl = row.querySelector('[data-sl-store-collect-dot]');
          if (textEl) { textEl.textContent = text; }
          if (dotEl) {
            dotEl.className = 'sl-dot' +
              (tone === 'success' ? ' sl-dot--success' : tone === 'warning' ? ' sl-dot--warning' : '');
          }
        }

        // Hidden and excluded stores need no lead time - paint them before the
        // fetch, and keep them out of `pending` so no lead time can repaint them.
        // Hidden first: it is the store's own answer and outranks the per-product
        // exclusion message, the same order updatePickup applies.
        var pending = [];
        stores.forEach(function (s) {
          if (isCollectHiddenEl(s)) { paint(s, '', hiddenMsg); }
          else if (s.hasAttribute('data-excluded')) { paint(s, '', excludedMsg); }
          else { pending.push(s); }
        });
        if (!pending.length) { return; }

        Promise.all([lookupAllCollections(), loadComponents()]).then(function (both) {
          var profiles = both[0];
          var components = both[1];
          if (!profiles) { return; }
          var ESD = window.ESDeliveryETA;
          if (!ESD) { whenETA(updateStoreCollection); return; }
          // Same rule as the selected-store row: a bundle is ready when its last
          // part is, so every store's window takes the later end across components.
          var entries = optsList(components);
          pending.forEach(function (s) {
            var profile = profiles[s.getAttribute('data-outlet') || ''];
            if (!profile) { return; }
            /* collectionWindow() takes the single-outlet response shape and bails
               unless `found` is set. The batch endpoint returns a map of bare
               profiles - presence in the map IS the hit - so the flag is added
               here rather than padding every entry of the payload with it. */
            var data = { found: true, leadTimeMin: profile.leadTimeMin, leadTimeMax: profile.leadTimeMax };
            var win = null;
            var blocked = false;
            entries.forEach(function (entry) {
              var w = ESD.collectionWindow(entry.opts, data);
              if (!w) { blocked = true; return; }
              if (!win) { win = w; return; }
              if (w.min.getTime() > win.min.getTime()) { win.min = w.min; }
              if (w.max.getTime() > win.max.getTime()) { win.max = w.max; }
              if (!w.confident) { win.confident = false; }
            });
            if (blocked) { win = null; }
            if (!win) {
              // No stock and no usable ETA: nothing honest to promise.
              paint(s, '', 'Delivery to store: ' + noDateText(entries));
              return;
            }
            paint(s, win.confident ? 'success' : 'warning',
              'Delivery to store: ' + fmtPickupWindow(win));
          });
        });
      }

      function setPickup(tone, text) {
        if (pickupText) { pickupText.textContent = text; }
        if (pickupDot) {
          pickupDot.classList.remove('sl-dot--success', 'sl-dot--warning');
          if (tone === 'success') { pickupDot.classList.add('sl-dot--success'); }
          if (tone === 'warning') { pickupDot.classList.add('sl-dot--warning'); }
        }
      }

      // Look up a postcode's delivering outlet + transit via the worker. Resolves
      // to the response object, or null (disabled / network / non-OK). Cached.
      // `suburb` is optional and narrows the result within the postcode; the
      // worker falls back to the postcode's worst case when it is absent or is a
      // suburb the data does not list.
      function lookupTransit(pc, suburb) {
        if (!transitUrl || !pc) { return Promise.resolve(null); }
        var key = country + '|' + pc + '|' + (suburb || '');
        if (transitCache[key]) { return transitCache[key]; }
        var url = transitUrl + '/transit?postcode=' + encodeURIComponent(pc) +
          (suburb ? '&suburb=' + encodeURIComponent(suburb) : '') +
          '&country=' + encodeURIComponent(country);
        var p = fetch(url)
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
        transitCache[key] = p;
        return p;
      }

      // Worker-driven deliverability check, keyed off the entered postcode:
      //   - not deliverable (worker found:false) -> "no stores deliver here":
      //       show the no-nearby + request-quote panel if enabled, else a note.
      //   - deliverable / no postcode / worker unreachable -> clear.
      // The SELECTED store is deliberately not compared against the delivering
      // outlet - home delivery is postcode-driven and unrelated to which store
      // the customer picked (that only matters for pickup).
      function reconcileDelivery() {
        var st = loadState();
        var pc = st.postcode;
        if (!pc || !transitUrl) { hideDeliveryNote(); hideNoNearby(); return; }
        lookupTransit(pc, st.suburb).then(function (data) {
          var cur = loadState();
          // The user may have changed postcode while the request was in flight.
          if (cur.postcode !== pc) { return; }
          // Worker unreachable: don't block the customer.
          if (!data) { hideDeliveryNote(); hideNoNearby(); return; }

          if (!data.found) {
            // No outlet delivers to this postcode. Name the postcode when we
            // have the customer's own, otherwise the location name they picked.
            var place = cur.label || cur.postcode;
            if (noNearby) {
              showNoNearby(place);
              hideDeliveryNote();
            } else {
              // Defensive only: the panel now renders regardless of the quote
              // settings, so this branch should not be reachable. Kept so a
              // missing panel degrades to a note rather than silence.
              hideNoNearby();
              showDeliveryNote('Delivery unavailable', 'Unfortunately, none of our stores deliver to ' + place + '.');
            }
            return;
          }

          // Deliverable - clear any warnings and compute the arrival date.
          hideNoNearby();
          hideDeliveryNote();
          updateDeliveryLine(data);
        });
      }

      function showDeliveryNote(heading, body) {
        if (!deliveryNote) { return; }
        if (deliveryNoteHeading) { deliveryNoteHeading.textContent = heading || ''; }
        if (deliveryNoteBody) {
          if (body) { deliveryNoteBody.textContent = body; deliveryNoteBody.hidden = false; }
          else { deliveryNoteBody.textContent = ''; deliveryNoteBody.hidden = true; }
        }
        deliveryNote.hidden = false;
        // Nothing delivers here and no quote path is on offer, so the rows
        // below would read "Standard delivery: TBC / Estimated shipping: TBC" -
        // no information at all. Hide the card and leave the note plus Change
        // location. (With the quote panel enabled this branch never runs;
        // showNoNearby hides the whole selected panel instead.)
        if (delivery) { delivery.hidden = true; }
      }
      function hideDeliveryNote() {
        // Undo the hide above first, on the same rule renderInlineState uses -
        // this runs on paths where the note element itself is irrelevant, and
        // reconcileDelivery is async so it can land after a re-render.
        if (delivery) {
          var dst = loadState();
          delivery.hidden = !(dst.postcode || dst.name);
        }
        if (!deliveryNote) { return; }
        deliveryNote.hidden = true;
      }

      // No-deliverable-stores panel (product column). Replaces the inline/selected
      // states; the location line names the postcode (or the location name when
      // we have no postcode of the customer's own). The explanation below it is
      // merchant copy and does not change with the place.
      function showNoNearby(place) {
        if (!noNearby) { return; }
        if (noNearbyLocation) {
          noNearbyLocation.textContent = 'Delivery to ' + place;
          noNearbyLocation.hidden = false;
        }
        noNearby.hidden = false;
        if (inline) { inline.hidden = true; }
        if (selected) { selected.hidden = true; }
      }
      function hideNoNearby() {
        if (noNearby) { noNearby.hidden = true; }
      }

      function reflectMyStoreButtons() {
        var my = loadState();
        var myIndex = my.index != null ? String(my.index) : null;
        stores.forEach(function (store) {
          var btn = store.querySelector('[data-sl-setstore]');
          if (!btn) { return; }
          var isMine = store.getAttribute('data-index') === myIndex;
          btn.setAttribute('aria-pressed', isMine ? 'true' : 'false');
          var lbl = btn.querySelector('[data-sl-setstore-label]');
          var check = btn.querySelector('.sl-store__check');
          if (lbl) { lbl.textContent = isMine ? 'My store' : 'Set as my store'; }
          if (check) { check.hidden = !isMine; }
        });
      }

      drawer.addEventListener('click', function (e) {
        var setBtn = e.target.closest('[data-sl-setstore]');
        if (!setBtn) { return; }
        var store = setBtn.closest('[data-sl-store]');
        var index = store.getAttribute('data-index');
        var current = loadState();
        // Clicking the store that is already "My store" de-selects it (postcode kept).
        if (current.name && String(current.index) === index) {
          clearStore();
        } else {
          setStore(index, store.getAttribute('data-name'), store.getAttribute('data-outlet'));
        }
        reflectMyStoreButtons();
        renderInlineState();
      });

      /* Nearest store with the item on display, when it is beyond the limit.
         Distances come from the same _dist the list is sorted on, so the panel
         can never disagree with what the rows show. */
      function reconcileTooFar() {
        if (!toofar) { return; }
        if (!toofarLocated || !toofarStock || !toofarLimit) { toofar.hidden = true; return; }
        var best = null;
        stores.forEach(function (store) {
          /* A warehouse can never be the nearest store with the item on display
             - it has no display floor (#1173). Left in and it would name one in
             a sentence the store's own row contradicts. */
          if (isWarehouseEl(store)) { return; }
          var hit = toofarStock[store.getAttribute('data-outlet') || ''];
          var available = hit ? hit.available : null;
          /* On display is available >= 1 - the same test fisState applies. */
          if (available === null || available === undefined || isNaN(available) || available < 1) { return; }
          var d = store._dist;
          if (typeof d !== 'number' || d === Number.MAX_VALUE) { return; }
          if (!best || d < best.dist) { best = { dist: d, name: store.getAttribute('data-name') || '' }; }
        });
        /* Nothing on display in ANY store. There is no store or distance to
           name, so this state has its own heading and its own line rather than
           filling the [store]/[distance] sentence with blanks. The three gates
           above still apply unchanged, so it cannot appear before a location is
           known and the stock answer has resolved - the panel only ever renders
           for display-stock products in the first place. */
        if (!best) {
          if (toofarHeading) {
            toofarHeading.textContent = toofarHeading.getAttribute('data-heading-none') || '';
          }
          if (toofarLine) {
            toofarLine.textContent = toofarHeading ? (toofarHeading.getAttribute('data-line-none') || '') : '';
          }
          toofar.hidden = false;
          return;
        }
        /* The nearest one is close enough to be worth showing in the list instead. */
        if (best.dist <= toofarLimit) { toofar.hidden = true; return; }
        /* Restore this state's heading - the none-state above may have
           overwritten it on an earlier pass. */
        if (toofarHeading) {
          toofarHeading.textContent = toofarHeading.getAttribute('data-heading-far') || '';
        }
        if (toofarLine) {
          toofarLine.textContent = toofarTpl
            .replace('[store]', best.name)
            .replace('[distance]', fmtKm(best.dist) + 'km');
        }
        toofar.hidden = false;
      }

      // ----- Location search: sort the store list by distance -----
      // Deliverability (the "no stores deliver here" gate) is decided by the
      // worker on the postcode, not by distance - see reconcileDelivery.
      function fmtKm(d) {
        return d < 10 ? d.toFixed(1) : String(Math.round(d));
      }

      function locateAt(lat, lng) {
        savePoint(lat, lng);
        stores.forEach(function (store) {
          var sLat = parseFloat(store.getAttribute('data-lat'));
          var sLng = parseFloat(store.getAttribute('data-lng'));
          var distEl = store.querySelector('[data-sl-distance]');
          if (isNaN(sLat) || isNaN(sLng)) {
            store._dist = Number.MAX_VALUE;
            return;
          }
          var d = haversine(lat, lng, sLat, sLng);
          store._dist = d;
          if (distEl) {
            distEl.textContent = fmtKm(d) + 'km';
            distEl.hidden = false;
          }
        });

        if (empty) { empty.hidden = true; }

        // Order by distance, show the 10 closest (for collection / viewing). The
        // full store list still exists regardless of deliverability.
        var ordered = stores.slice().sort(function (a, b) { return (a._dist || 0) - (b._dist || 0); });
        ordered.forEach(function (store, rank) {
          list.appendChild(store);
          store.hidden = rank >= 10;
        });

        /* Frame the shopper AND their nearest store, rather than dropping a
           fixed zoom 10 on the point and hoping a pin falls inside it. */
        if (map) { frameLocation(lat, lng, ordered.length ? ordered[0] : null); }

        toofarLocated = true;
        reconcileTooFar();
      }

      /* Fit the map to the shopper's point plus one store. Falls back to the old
         fixed zoom when there is no usable store to include. */
      function frameLocation(lat, lng, storeEl) {
        if (!map || !window.google) { return; }
        var sLat = storeEl ? parseFloat(storeEl.getAttribute('data-lat')) : NaN;
        var sLng = storeEl ? parseFloat(storeEl.getAttribute('data-lng')) : NaN;
        if (isNaN(sLat) || isNaN(sLng)) {
          map.setCenter({ lat: lat, lng: lng });
          map.setZoom(10);
          return;
        }
        var b = new google.maps.LatLngBounds();
        b.extend({ lat: lat, lng: lng });
        b.extend({ lat: sLat, lng: sLng });
        // Padding keeps both pins off the edge of the canvas.
        map.fitBounds(b, 64);
        /* A store almost on top of the shopper would otherwise fit to street
           level, which loses all sense of where they are. fitBounds settles
           asynchronously, so the cap has to wait for the map to be idle. */
        google.maps.event.addListenerOnce(map, 'idle', function () {
          if (map.getZoom() > 14) { map.setZoom(14); }
        });
      }

      // Reset the list to its default: hide the empty message, restore every
      // store (original order), drop the distances, re-fit the map.
      function resetResults() {
        // Clearing the search clears the point too, so the next open frames the
        // country again rather than a location the shopper has just discarded.
        clearPoint();
        if (empty) { empty.hidden = true; }
        if (noNearby) { noNearby.hidden = true; }
        stores.forEach(function (store) {
          list.appendChild(store);
          store.hidden = false;
          store.classList.remove('is-active');
          var distEl = store.querySelector('[data-sl-distance]');
          if (distEl) { distEl.hidden = true; distEl.textContent = ''; }
        });
        if (map && gMarkers.length && window.google) {
          var b = new google.maps.LatLngBounds();
          gMarkers.forEach(function (m) { b.extend(m.marker.getPosition()); });
          map.fitBounds(b);
        }
      }

      // ----- Google Map -----
      var map = null, gMarkers = [], geocoder = null, mapsRequested = false;
      // A postcode taken from the logged-in customer's saved address, waiting for
      // the geocoder so it can be turned into a store selection. Cleared once used.
      var pendingAccountPostcode = null;
      /* Set by any path that should hand the shopper their nearest store when
         they have not chosen one: the account-seeded lookup, and a suburb picked
         from the suggestions or typed into Search (#992, Daniel's UAT - choosing
         a suburb set the delivery location but left "no store selected").

         It only ever FILLS AN EMPTY SLOT - setLocation checks loadState().name
         before acting - so a reader who has already chosen a store keeps it, and
         a later search just re-sorts the list. The geolocate button is the one
         path that reassigns outright, because the prompt names the store and the
         shopper agrees to it. One shot: setLocation clears the flag as it acts. */
      var autoSelectNearest = false;
      // acFetch is the autocomplete's suggestion fetcher once Places has loaded;
      // pendingTerm queues a term to suggest for if it isn't ready yet.
      var acFetch = null, pendingTerm = null;
      // The same pair for the inline PDP field (#19498855), which loads Maps
      // itself the first time someone types into it.
      var inlineFetch = null, pendingInlineTerm = null;

      // Keep the drawer field and the inline field showing the same location,
      // whichever one the reader used to choose it.
      function mirrorLocationValue(value) {
        var d = drawer.querySelector('[data-sl-search-input]');
        var i = root.querySelector('[data-sl-inline-input]');
        if (d) { d.value = value; }
        if (i) { i.value = value; }
      }

      function buildMap() {
        var canvas = drawer.querySelector('[data-sl-map-canvas]');
        if (!canvas || !window.google || !window.google.maps) { return; }
        map = new google.maps.Map(canvas, { zoom: 4, center: { lat: -25.27, lng: 133.77 }, mapTypeControl: false, streetViewControl: false, fullscreenControl: false, styles: MAP_STYLE });
        geocoder = new google.maps.Geocoder();
        /* Seeded from the customer's account address at init but not actionable
           until now, since resolving a postcode to a store needs the geocoder.
           Re-checked against saved state because the reader may have chosen a
           store between page load and the map loading. */
        if (pendingAccountPostcode) {
          var seedPc = pendingAccountPostcode;
          pendingAccountPostcode = null;
          if (!loadState().postcode) {
            autoSelectNearest = true;
            runSearch(seedPc);
          }
        }
        var markerSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="29" viewBox="30 96 14.324 17.307" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M37.1614 96C41.1166 96 44.3233 99.2062 44.3235 103.161C44.3235 107.936 37.1614 113.307 37.1614 113.307C37.1135 113.271 30 107.92 30 103.161C30.0002 99.2063 33.2063 96.0002 37.1614 96ZM37.2614 100.741C36.1978 100.741 35.3354 101.603 35.3353 102.666C35.3353 103.73 36.1978 104.592 37.2614 104.592C38.3249 104.592 39.1868 103.73 39.1868 102.666C39.1867 101.603 38.3249 100.741 37.2614 100.741Z" fill="#302520"/><circle cx="37.2614" cy="102.6665" r="1.925" fill="#f5f3eb"/></svg>';
        var markerIcon = {
          url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(markerSvg),
          scaledSize: new google.maps.Size(24, 29),
          anchor: new google.maps.Point(12, 29)
        };
        var bounds = new google.maps.LatLngBounds();
        locations.forEach(function (loc) {
          var pos = { lat: loc.lat, lng: loc.lng };
          var marker = new google.maps.Marker({ position: pos, map: map, title: loc.name, icon: markerIcon });
          marker.addListener('click', function () { focusStore(loc.i); });
          gMarkers.push({ index: loc.i, marker: marker });
          bounds.extend(pos);
        });
        /* Open where the shopper left off. The drawer used to fit every pin in
           the country even when their location was already known (#19498854),
           so the first thing they had to do was tell it again. Same order of
           preference as the store locator page, and the same shared state, so
           the two agree. */
        var saved = loadState();
        if (typeof saved.lat === 'number' && typeof saved.lng === 'number') {
          locateAt(saved.lat, saved.lng);
        } else if (saved.postcode) {
          runSearch(saved.postcode);
        } else if (locations.length) {
          map.fitBounds(bounds);
        }
        wireAutocomplete();
      }

      /* Binds the typeahead to both fields once Places is available. Called from
         buildMap, and again when the inline field first loads Maps on its own -
         whichever happens first wins, the __acInit guard makes the second a
         no-op. */
      function wireAutocomplete() {
        var fetcher = setupAutocomplete(
          searchInput,
          drawer.querySelector('[data-sl-suggestions]'),
          '.sl-search'
        );
        if (fetcher) {
          // Expose the fetcher + drain any term queued before Places loaded, so a
          // value carried in from the inline field shows suggestions immediately.
          acFetch = fetcher;
          if (pendingTerm) { fetcher(pendingTerm); pendingTerm = null; }
        }

        var inlineFetcher = setupAutocomplete(
          inlineInput,
          root.querySelector('[data-sl-inline-suggestions]'),
          '.sl-inline-search',
          function () { confirmInline(); }
        );
        if (inlineFetcher) {
          inlineFetch = inlineFetcher;
          /* The term that triggered the Maps load was typed BEFORE this listener
             existed, so nothing would suggest for it until the next keystroke.
             Drain it, same as pendingTerm does for the drawer. */
          if (pendingInlineTerm) { inlineFetch(pendingInlineTerm); pendingInlineTerm = null; }
        }
      }

      // Google Places typeahead (Places API New: AutocompleteSuggestion). We fetch
      // suggestions and render our OWN dropdown ([data-sl-suggestions]) inside the
      // dialog, so it keeps the field styling and paints in the <dialog> top layer
      // (no legacy .pac-container z-index problem).
      //
      // Bound to a FIELD rather than to the drawer (#19498855): the same typeahead
      // now runs on the inline PDP field, which previously had none at all - typing
      // there did nothing until Confirm was pressed, which merely opened the drawer.
      // Parameterised rather than duplicated so debounce, skeleton, keyboard nav,
      // session tokens and includedPrimaryTypes cannot drift between the two.
      //
      //   input     the text field to bind
      //   listbox   its own <ul> (each field owns one; they never share)
      //   scopeSel  selector for the wrapper an outside-click must fall outside of
      //   onEnter   fallback when Enter is pressed with no suggestion highlighted
      function setupAutocomplete(input, listbox, scopeSel, onEnter) {
        if (!input || input.__acInit) { return null; }
        var places = google.maps.places;
        if (!places || !places.AutocompleteSuggestion || !places.AutocompleteSessionToken) { return null; }
        input.__acInit = true;

        var searchInput = input;
        // One per listbox row - see googleEntry / suburbEntry.
        var entries = [];
        var activeIndex = -1;
        var token = null;
        var debounce = null;
        /* Country restriction from the "Limit address results to countries"
           theme setting. Blank means no restriction (worldwide results). */
        var regions = (drawer.getAttribute('data-maps-regions') || '')
          .split(',')
          .map(function (c) { return c.trim().toLowerCase(); })
          .filter(function (c) { return c.length === 2; })
          .slice(0, 15);

        function closeList() {
          if (listbox) { listbox.hidden = true; listbox.innerHTML = ''; }
          entries = [];
          activeIndex = -1;
        }

        function highlight() {
          if (!listbox) { return; }
          var items = listbox.children;
          for (var i = 0; i < items.length; i++) {
            items[i].classList.toggle('is-active', i === activeIndex);
          }
        }

        /* One entry per ROW in the listbox, whatever fed it - a Google
           prediction or a suburb from our own postcode data (#1190). Keeping a
           single uniform list is what lets the keyboard index and the DOM stay
           aligned once the list holds a mix of the two; the old shape indexed
           straight into Google's array, which cannot describe our rows.

           `main` is what the dedupe compares on: Google's main text, which for
           a postcode query is the postcode itself and for a suburb is the
           suburb name. */
        function googleEntry(sugg) {
          var pred = sugg && sugg.placePrediction;
          if (!pred) { return null; }
          return {
            label: pred.text ? pred.text.text : '',
            /* The suburb Google MEANT, via the same helper the pick path uses -
               not the raw main text. For a postcode query Google packs the
               state in with it ("Harman ACT 2600"), which normalises to
               something our "Harman" can never match, and the suburb then
               appeared twice (#1190). */
            main: suburbFromPrediction(pred),
            pick: function () { chooseGoogle(sugg); }
          };
        }

        /* Formatted to sit beside Google's own rows rather than to look like a
           second kind of thing. Google writes "Barton ACT 2600, Australia"; we
           have no state column in the supply, so ours reads "Barton 2600,
           Australia" - the same shape, one field short. */
        function countryName() {
          return country === 'NZ' ? 'New Zealand' : 'Australia';
        }

        function suburbEntry(name, padded) {
          return {
            label: name + ' ' + padded + ', ' + countryName(),
            main: name,
            pick: function () { chooseSuburb(name, padded); }
          };
        }

        /* A suburb the shopper picked from OUR data. It has to finish in exactly
           the state a Google pick finishes in, and it nearly is one already: the
           postcode and the suburb are both known, so only the point is missing.
           That comes from the same geocoder the typed-search path uses, asked
           for "Suburb Postcode Country" and biased to this storefront's market,
           after which the normal setLocation flow runs untouched. */
        function chooseSuburb(name, padded) {
          if (!geocoder) { return; }
          mirrorLocationValue(name);
          token = null;
          closeList();
          geocoder.geocode(
            { address: name + ' ' + padded + ' ' + countryName(), region: country.toLowerCase() },
            function (results, status) {
              if (status !== 'OK' || !results[0] || !results[0].geometry) { return; }
              var loc = results[0].geometry.location;
              autoSelectNearest = true;
              /* Postcode and suburb come from our own data, not from the
                 geocode: the shopper chose them, and the geocode is only being
                 asked where that is. */
              setLocation(loc.lat(), loc.lng(), padded, name, name);
            }
          );
        }

        function chooseGoogle(sugg) {
          var pred = sugg && sugg.placePrediction;
          if (!pred) { return; }
          var place = pred.toPlace();
          place.fetchFields({ fields: ['location', 'addressComponents'] }).then(function () {
            if (!place.location) { return; }
            var text = function (c) { return c.longText; };
            var pc = postcodeFromComponents(place.addressComponents, text);
            var suburb = localityFromComponents(place.addressComponents, text);
            /* Suburb the shopper picked, for the messages. 'suburb' above stays
               as it was - it narrows the transit lookup and is Google's own
               locality, which is not always the one shown in the dropdown. */
            var label = suburbFromPrediction(pred) || (pred.text ? pred.text.text : searchInput.value);
            /* Both fields carry the chosen location, whichever one was used to
               pick it - the same pairing the clear button and the init pre-fill
               already keep. Without this, picking inline left the drawer's field
               showing nothing. */
            mirrorLocationValue(label);
            token = null;
            /* Give them their nearest store if they have none yet - see the flag's
               note. Set before setLocation, which reads it once the list is sorted. */
            autoSelectNearest = true;
            setLocation(place.location.lat(), place.location.lng(), pc, label, suburb);
            closeList();
          }).catch(function () {});
        }

        /* Every row is built here, from either source, so a suburb of ours is
           indistinguishable from a Google row - same element, same class, same
           role, same mousedown behaviour. */
        function appendRow(entry) {
          var li = document.createElement('li');
          li.className = 'sl-suggestions__item';
          li.setAttribute('role', 'option');
          li.textContent = entry.label;
          li.addEventListener('mousedown', function (ev) { ev.preventDefault(); entry.pick(); });
          listbox.appendChild(li);
          return li;
        }

        function render(list) {
          entries = [];
          activeIndex = -1;
          if (!listbox) { return; }
          listbox.innerHTML = '';
          (list || []).forEach(function (sugg) {
            var entry = googleEntry(sugg);
            /* Skipped rather than rendered blank, and now skipped from the
               entry list too - previously a prediction with no placePrediction
               left a hole that shifted every keyboard index after it. */
            if (!entry) { return; }
            entries.push(entry);
            appendRow(entry);
          });
          listbox.hidden = listbox.children.length === 0;
        }

        /* Our suburbs, appended AFTER Google's rows and only where Google has
           not already offered the same suburb (#1190). Google keeps its place
           at the top of the list; this only ever grows it. */
        function appendSuburbs(suburbs, padded) {
          var helper = window.__esSuburbSuggest;
          if (!helper || !listbox || !suburbs || !suburbs.length) { return; }
          var offered = entries.map(function (e) { return e.main; });
          helper.extras(offered, suburbs).forEach(function (name) {
            var entry = suburbEntry(name, padded);
            entries.push(entry);
            appendRow(entry);
          });
          listbox.hidden = listbox.children.length === 0;
        }

        function showSkeleton() {
          if (!listbox) { return; }
          listbox.innerHTML = '';
          for (var i = 0; i < 5; i++) {
            var li = document.createElement('li');
            li.className = 'sl-suggestions__item sl-suggestions__item--skeleton';
            li.setAttribute('aria-hidden', 'true');
            var bar = document.createElement('span');
            bar.className = 'sl-skeleton';
            li.appendChild(bar);
            listbox.appendChild(li);
          }
          listbox.hidden = false;
        }

        /* Guards against a slow response landing on a query the shopper has
           already typed past. Bumped per keystroke that reaches the network. */
        var reqSeq = 0;

        function fetchSuggestions(value) {
          if (!token) { token = new places.AutocompleteSessionToken(); }
          showSkeleton();
          var seq = ++reqSeq;
          var helper = window.__esSuburbSuggest;
          /* Only a postcode query gets the extra suburbs (#1190). A suburb-name
             search already returns the suburb itself, so it is left exactly as
             it was. */
          var padded = helper ? helper.asPostcode(value) : '';
          /* Started in PARALLEL and never awaited, so Google's list renders on
             its own timing whatever the worker does. If the worker is slow the
             rows arrive late; if it fails it resolves to [] and adds nothing. */
          var extrasPromise = padded
            ? helper.fetchSuburbs(transitUrl, country, padded)
            : null;
          /* Postcode, suburb and state - see the note in sections/store-locator.liquid.
             sublocality is what carries NZ suburbs; without it they return nothing. */
          var req = { input: value, sessionToken: token, includedPrimaryTypes: ['postal_code', 'locality', 'sublocality', 'administrative_area_level_1'] };
          if (regions.length) { req.includedRegionCodes = regions; }
          places.AutocompleteSuggestion.fetchAutocompleteSuggestions(req).then(function (res) {
            if (seq !== reqSeq) { return; }
            render(res && res.suggestions ? res.suggestions : []);
            if (!extrasPromise) { return; }
            extrasPromise.then(function (suburbs) {
              // Typed on since - the list on screen is answering a later query.
              if (seq !== reqSeq) { return; }
              appendSuburbs(suburbs, padded);
            });
          }).catch(function () { closeList(); });
        }

        searchInput.addEventListener('input', function () {
          var value = searchInput.value.trim();
          window.clearTimeout(debounce);
          if (value.length < 3) { closeList(); return; }
          debounce = window.setTimeout(function () { fetchSuggestions(value); }, 200);
        });

        // Enter with nothing highlighted falls back to the field's own action:
        // the drawer searches, the inline field confirms (opening the drawer),
        // which is what each did before this was shared.
        function enterFallback() {
          if (onEnter) { onEnter(searchInput.value.trim()); }
          else { runSearch(searchInput.value.trim()); }
        }

        searchInput.addEventListener('keydown', function (e) {
          if (listbox.hidden || !listbox.children.length) {
            if (e.key === 'Enter') { e.preventDefault(); enterFallback(); }
            return;
          }
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            activeIndex = Math.min(activeIndex + 1, listbox.children.length - 1);
            highlight();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            activeIndex = Math.max(activeIndex - 1, 0);
            highlight();
          } else if (e.key === 'Enter') {
            e.preventDefault();
            if (activeIndex >= 0 && entries[activeIndex]) { entries[activeIndex].pick(); }
            else { enterFallback(); }
          } else if (e.key === 'Escape') {
            closeList();
          }
        });

        document.addEventListener('click', function (e) {
          if (!e.target.closest(scopeSel)) { closeList(); }
        });

        return fetchSuggestions;
      }

      function loadMaps() {
        if (mapsRequested) { return; }
        mapsRequested = true;
        if (window.google && window.google.maps) { buildMap(); return; }
        var key = drawer.getAttribute('data-maps-key');
        if (!key) { return; }
        window.__esSlMapInit = function () { buildMap(); };
        var s = document.createElement('script');
        s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&libraries=places&callback=__esSlMapInit';
        s.async = true;
        document.head.appendChild(s);
      }

      function focusStore(index) {
        var store = drawer.querySelector('[data-sl-store][data-index="' + index + '"]');
        if (!store) { return; }
        stores.forEach(function (s) { s.classList.remove('is-active'); });
        store.classList.add('is-active');
        openStore(store); // closes any other open accordion + zooms the map
        // Let the open/close transitions settle before scrolling so the target
        // lands in the right place under the sticky map.
        window.setTimeout(function () {
          store.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 320);
      }

      // Resolve a searched/selected place into state + list.
      //   postcode - the place's own postal_code (blank for a suburb/town/city)
      //   label    - the place's human-readable name (for messaging)
      //   suburb   - the place's locality, for the suburb-level transit lookup
      // Not every Google place carries a postcode (a locality can span many), so
      // when it's blank we reverse-geocode the point to get one for the worker
      // lookup, and keep the label to show in messages instead of that postcode.
      // The reverse geocode also yields the suburb when the place had none.
      function setLocation(lat, lng, postcode, label, suburb) {
        if (postcode) {
          /* Was passing '' here, which is what dropped the suburb whenever a
             postcode resolved and left the message showing the postcode. */
          applyLocation(lat, lng, postcode, label || '', suburb || '');
        } else {
          reverseGeocodePostcode(lat, lng, function (pc, geoSuburb) {
            applyLocation(lat, lng, pc, label || '', suburb || geoSuburb || '');
          });
        }
      }

      function applyLocation(lat, lng, lookupPostcode, label, suburb) {
        if (lookupPostcode) { setLocationState(lookupPostcode, label, suburb); }
        else { clearPostcode(); }
        /* Marker so the recalculation is visible in the console (#19528022).
           Every location change routes through here - dropdown pick, typed
           search, locate-me - so one line here proves the new location was
           picked up. The delivery and pickup calcs that follow print their own
           workings, and the transit response is cached per postcode+suburb, so
           a repeat of the same location will not re-fetch but will still
           recalculate and log below. */
        console.log('[store-locator] Location set -> ' +
          (lookupPostcode || '(cleared)') +
          (suburb ? ' / ' + suburb : '') +
          ' - recalculating delivery and pickup');
        renderInlineState();
        locateAt(lat, lng);
        /* Hand them the closest store when they have none, so setting a location
           lands on a chosen store rather than a sorted list plus a button to
           press. One shot, and only while nothing is chosen: a reader who has
           already picked a store keeps it, and this re-sorts the list around
           their new location instead. */
        if (autoSelectNearest) {
          autoSelectNearest = false;
          var chosen = loadState().name;
          if (!chosen) {
            selectNearestStore();
            console.log('[store-locator] No store chosen yet -> selected the nearest to ' +
              (lookupPostcode || suburb || 'the new location') + ': ' + (loadState().name || '(none found)'));
          } else {
            console.log('[store-locator] Store already chosen (' + chosen + ') -> kept it, list re-sorted only');
          }
        }
      }

      /* The closest store after locateAt() has ordered the list: it appends in
         distance order, so the first visible row is the nearest. Reads the DOM
         rather than _dist so it can never disagree with what is on screen. */
      /* Nearest store to a point, worked out WITHOUT touching the list.
         selectNearestStore() below reads the first row instead, which only works
         once locateAt() has sorted them - fine after the fact, useless here,
         because the prompt has to name the store BEFORE the shopper agrees and
         nothing on screen should move until they do. Skips hidden rows for the
         same reason selectNearestStore does: a store filtered out of the list is
         not one to hand them. */
      function nearestStoreTo(lat, lng) {
        var best = null;
        var bestDist = Infinity;
        for (var i = 0; i < stores.length; i++) {
          var candidate = stores[i];
          if (candidate.hidden) { continue; }
          var sLat = parseFloat(candidate.getAttribute('data-lat'));
          var sLng = parseFloat(candidate.getAttribute('data-lng'));
          if (isNaN(sLat) || isNaN(sLng)) { continue; }
          var d = haversine(lat, lng, sLat, sLng);
          if (d < bestDist) { bestDist = d; best = candidate; }
        }
        return best;
      }

      function selectNearestStore() {
        var nearest = null;
        for (var i = 0; i < stores.length; i++) {
          var candidate = list.children[i];
          if (candidate && candidate.hasAttribute && candidate.hasAttribute('data-sl-store') && !candidate.hidden) {
            nearest = candidate;
            break;
          }
        }
        if (!nearest) { return; }
        setStore(nearest.getAttribute('data-index'),
                 nearest.getAttribute('data-name'),
                 nearest.getAttribute('data-outlet'));
        reflectMyStoreButtons();
        renderInlineState();
      }

      // Reverse-geocode a point to its postcode + suburb (most specific first).
      function reverseGeocodePostcode(lat, lng, cb) {
        if (!geocoder) { cb('', ''); return; }
        geocoder.geocode({ location: { lat: lat, lng: lng } }, function (results, status) {
          var pc = '';
          var suburb = '';
          var text = function (c) { return c.long_name; };
          if (status === 'OK' && results) {
            for (var i = 0; i < results.length && !pc; i++) {
              pc = postcodeFromComponents(results[i].address_components, text);
            }
            for (var j = 0; j < results.length && !suburb; j++) {
              suburb = localityFromComponents(results[j].address_components, text);
            }
          }
          cb(pc, suburb);
        });
      }

      function postcodeFromComponents(components, getText) {
        if (!components) { return ''; }
        for (var i = 0; i < components.length; i++) {
          var types = components[i].types || [];
          if (types.indexOf('postal_code') !== -1) { return getText(components[i]); }
        }
        return '';
      }

      // The suburb, for the worker's suburb-level transit lookup. A postcode can
      // cover suburbs with different transit times, so the suburb narrows it;
      // without one the worker returns the postcode's worst case. `locality` is
      // the AU suburb; `sublocality` covers the places Google files one level down.
      /* Display name for the location - the suburb, and the same wording every
         time (#19498861). The row used to read "Delivery to 3008" or "Delivery
         to Melbourne VIC, Australia" depending on which path set it.

         Taken from what the shopper actually picked in the dropdown. Places
         splits a prediction in two: for a suburb the name is the main text
         ("Ponsonby", secondary "Auckland, New Zealand"), but for a POSTCODE the
         main text is the postcode itself and the suburb sits at the front of
         the secondary text ("3083", secondary "Kingsbury VIC, Australia") - so
         which half to read depends on what was matched.

         Deliberately NOT read from the address components, which look like the
         obvious source but disagree with the dropdown: the 3083 place carries a
         locality of Bundoora while the dropdown offers Kingsbury, and NZ is
         worse - Ponsonby has a locality of Auckland, losing the suburb the
         shopper chose. Whatever they picked is what gets shown back to them. */
      function suburbFromPrediction(pred) {
        if (!pred) { return ''; }
        var main = pred.mainText && pred.mainText.text ? pred.mainText.text : '';
        var secondary = pred.secondaryText && pred.secondaryText.text ? pred.secondaryText.text : '';
        var name = main;
        if (/^\d+$/.test(main.replace(/\s/g, ''))) { name = secondary; }
        name = name.split(',')[0];
        /* Trailing state abbreviation, e.g. "Kingsbury VIC". AU only - NZ
           secondary text carries a city rather than a state code. */
        return name.replace(/\s+(VIC|NSW|QLD|SA|WA|TAS|ACT|NT)$/i, '').trim();
      }

      function localityFromComponents(components, getText) {
        if (!components) { return ''; }
        var fallback = '';
        for (var i = 0; i < components.length; i++) {
          var types = components[i].types || [];
          if (types.indexOf('locality') !== -1) { return getText(components[i]); }
          if (!fallback && (types.indexOf('sublocality') !== -1 || types.indexOf('sublocality_level_1') !== -1)) {
            fallback = getText(components[i]);
          }
        }
        return fallback;
      }

      // Fallback for the Search button / Enter (no autocomplete selection):
      // geocode the typed text (AU-biased), then resolve postcode + distance.
      function runSearch(query) {
        if (!query || !geocoder) { return; }
        geocoder.geocode({ address: query, region: 'au' }, function (results, status) {
          if (status === 'OK' && results[0]) {
            var loc = results[0].geometry.location;
            var text = function (c) { return c.long_name; };
            var pc = postcodeFromComponents(results[0].address_components, text);
            var suburb = localityFromComponents(results[0].address_components, text);
            /* No prediction on this path (typed text, Enter or the Search
               button), so the suburb comes from the geocode. Only falls back to
               the full formatted address when there is no locality at all. */
            var label = suburb || results[0].formatted_address || query;
            // Same rule as the suggestion path, or the two ways of entering the
            // same suburb would behave differently.
            autoSelectNearest = true;
            setLocation(loc.lat(), loc.lng(), pc, label, suburb);
          } else if (empty) {
            empty.hidden = false;
          }
        });
      }

      /* "Use my current location" (#19498854).

         This used to call locateAt() straight from the coordinates, which only
         re-sorts the store list by distance. It never went through setLocation,
         so nothing was reverse geocoded, the field stayed empty and nothing was
         saved - the map moved and the shopper had no idea what had been
         detected. Every other entry point goes through setLocation; this one
         quietly did not.

         Now it resolves the place first, shows it for confirmation, and only
         commits when the shopper agrees. The confirmation lives in the Location
         prompt section, which is merchant content and can be absent from a
         store, so a missing prompt falls back to applying the location directly
         rather than doing nothing at all. */
      /* reverseGeocodePostcode answers ('', '') when the Geocoder does not exist
         yet, which this flow would read as a failed lookup. The drawer loads
         Maps when it opens, but a shopper can reach the button before the script
         has landed, so wait for it rather than reporting a failure that is only
         a race. Gives up after ~5s and lets the caller report a real failure. */
      function whenGeocoderReady(cb) {
        if (geocoder) { cb(true); return; }
        loadMaps();
        var waited = 0;
        var poll = window.setInterval(function () {
          waited += 100;
          if (geocoder) { window.clearInterval(poll); cb(true); }
          else if (waited >= 5000) { window.clearInterval(poll); cb(false); }
        }, 100);
      }

      /* Pressing "use my current location" can sit for several seconds - the
         browser's own permission prompt first, then the fix, then the reverse
         geocode - with nothing on screen to say the press landed (#19500365,
         reported as "it can feel like nothing is happening"). For that whole
         wait the button shows a spinner in place of its icon.

         geoDone() is idempotent and runs on EVERY exit: the confirmation prompt
         appearing, a geocoder that never readied, a lookup that found nothing,
         and a denied or dismissed permission. It also runs on a watchdog,
         because getCurrentPosition has no timeout of its own - an unanswered
         permission prompt would otherwise leave the button spinning forever,
         which is worse than the dead button it replaced. */
      var geoTimer = null;

      function geoButtons() {
        /* Every geo control in this component, not just one. They all drive the
           same single lookup, so they share one pending state - press the inline
           one and the drawer's button is busy too, and the repeat-press guard
           below stays a single check whichever was pressed. */
        var found = [];
        [root, drawer].forEach(function (scope) {
          if (!scope) { return; }
          scope.querySelectorAll('[data-sl-geo], [data-sl-inline-geo]').forEach(function (btn) {
            if (found.indexOf(btn) === -1) { found.push(btn); }
          });
        });
        return found;
      }

      function geoBusy() {
        geoButtons().forEach(function (btn) {
          btn.classList.add('is-loading');
          btn.setAttribute('aria-busy', 'true');
        });
        if (geoTimer) { clearTimeout(geoTimer); }
        geoTimer = setTimeout(geoDone, 20000);
      }

      function geoDone() {
        if (geoTimer) { clearTimeout(geoTimer); geoTimer = null; }
        geoButtons().forEach(function (btn) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        });
      }

      function geolocate() {
        if (!navigator.geolocation) { return; }
        /* Already pending: ignore the repeat press rather than starting
           a second lookup behind the first. */
        var pending = geoButtons().filter(function (btn) { return btn.classList.contains('is-loading'); });
        if (pending.length) { return; }
        geoBusy();
        navigator.geolocation.getCurrentPosition(function (pos) {
          var lat = pos.coords.latitude;
          var lng = pos.coords.longitude;
          whenGeocoderReady(function (ready) {
            if (!ready) {
              geoDone();
              if (window.esLocationPrompt) { window.esLocationPrompt.notify('failed'); }
              return;
            }
            reverseGeocodePostcode(lat, lng, function (pc, suburb) {
              if (!pc && !suburb) {
                geoDone();
                if (window.esLocationPrompt) { window.esLocationPrompt.notify('failed'); }
                return;
              }
              var near = nearestStoreTo(lat, lng);
              var apply = function () {
                /* Same pipeline the dropdown uses, so the field, the stored
                   location and the store list all move together. */
                setLocation(lat, lng, pc, suburb, suburb);
                var shown = suburb || pc;
                if (searchInput && shown) { searchInput.value = shown; }
                if (inlineInput && shown) { inlineInput.value = shown; }

                /* Set the nearest store as theirs. A typed search deliberately
                   does NOT do this - it only sorts the list and lets the reader
                   choose - but here the store was named in the prompt and the
                   shopper pressed the button, so it is their choice rather than
                   a silent reassignment. Set unconditionally for that reason,
                   where the account-seeded path only fills an empty slot. */
                if (near) {
                  setStore(near.getAttribute('data-index'),
                           near.getAttribute('data-name'),
                           near.getAttribute('data-outlet'));
                  reflectMyStoreButtons();
                  renderInlineState();
                }
              };
              if (!window.esLocationPrompt) { geoDone(); apply(); return; }
              /* Cleared as the prompt opens, NOT when it is answered - the wait
                 the spinner covers is over the moment there is something to
                 look at, and the button sits behind the prompt until then. */
              geoDone();
              window.esLocationPrompt
                .confirm({
                  suburb: suburb,
                  postcode: pc,
                  store: near ? near.getAttribute('data-name') : ''
                })
                .then(function (ok) { if (ok) { apply(); } });
            });
          });
        }, function () {
          // Blocked, dismissed, or timed out. Silence here reads as a dead
          // button, which is what was reported.
          geoDone();
          if (window.esLocationPrompt) { window.esLocationPrompt.notify('denied'); }
        });
      }

      // ----- Wire search controls -----
      var searchInput = drawer.querySelector('[data-sl-search-input]');
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-sl-search]')) { runSearch(searchInput ? searchInput.value.trim() : ''); }
        if (e.target.closest('[data-sl-geo]')) { geolocate(); }
        if (e.target.closest('[data-sl-clear]')) {
          if (searchInput) { searchInput.value = ''; searchInput.focus(); }
          if (inlineInput) { inlineInput.value = ''; }
          clearPostcode();
          renderInlineState();
          resetResults();
        }
      });
      if (searchInput) {
        searchInput.addEventListener('keydown', function (e) {
          // The new-Places autocomplete owns Enter/Arrow keys once it's wired.
          if (searchInput.__acInit) { return; }
          if (e.key === 'Enter') { e.preventDefault(); runSearch(searchInput.value.trim()); }
        });
      }

      // ----- Inline element controls -----
      var inlineInput = root.querySelector('[data-sl-inline-input]');

      // Carry the inline term into the drawer, open it, and show suggestions for
      // that term (queued via pendingTerm if Places hasn't loaded yet).
      function confirmInline() {
        var q = inlineInput ? inlineInput.value.trim() : '';
        if (q && searchInput) { searchInput.value = q; }
        if (window.esDrawer) { window.esDrawer.open('store-locator-drawer', inlineInput); }
        if (!q) { return; }
        if (acFetch) { window.setTimeout(function () { acFetch(q); }, 50); }
        else { pendingTerm = q; }
      }

      if (inlineInput) {
        inlineInput.addEventListener('keydown', function (e) {
          // Once the typeahead is wired it owns Enter and the arrow keys, and
          // falls back to confirmInline when nothing is highlighted.
          if (inlineInput.__acInit) { return; }
          if (e.key === 'Enter') { e.preventDefault(); confirmInline(); }
        });

        /* Suggestions on the PDP field itself (#19498855). It used to have no
           typeahead at all: Maps loaded only when the drawer opened, so typing
           here did nothing and Confirm just opened the sidebar. Loading Maps on
           the third character - the same threshold the typeahead itself uses -
           keeps the script off anyone who merely tabs through the field, and the
           term is queued so it suggests as soon as Places is ready. */
        inlineInput.addEventListener('input', function () {
          if (inlineInput.__acInit) { return; }
          var value = inlineInput.value.trim();
          if (value.length < 3) { return; }
          pendingInlineTerm = value;
          if (window.google && window.google.maps && window.google.maps.places) { wireAutocomplete(); }
          else { loadMaps(); }
        });
      }

      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-sl-confirm]')) { confirmInline(); }
        if (e.target.closest('[data-sl-inline-geo]')) {
          /* Locate-me on the inline field used to open the drawer first and
             geolocate 400ms later, because it had nowhere else to show a
             result. The confirmation modal is that place now, so this stays on
             the product page and the drawer is left alone (#19498854).
             geolocate() loads Maps itself, which the drawer's toggle used to do
             on its behalf. */
          geolocate();
        }
      });

      // Lazy-load the map AND the Rex stock lookup the first time the drawer
      // opens - updateOnDisplay gates itself on engagement, and opening the
      // drawer is what makes its rows visible.
      drawer.addEventListener('toggle', function () { if (drawer.open) { loadMaps(); updateOnDisplay(); } });
      // Fallback for browsers without dialog 'toggle': hook the global trigger.
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-drawer-trigger="store-locator-drawer"]')) {
          window.setTimeout(function () { loadMaps(); updateOnDisplay(); }, 50);
        }
      });

      // Dismissable store-collection footer (persists once closed).
      var collection = drawer.querySelector('[data-sl-collection]');
      var DISMISS_KEY = 'es:store-collection-dismissed';
      function isCollectionDismissed() {
        try { return window.localStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
      }
      if (collection && isCollectionDismissed()) { collection.hidden = true; }
      drawer.addEventListener('click', function (e) {
        if (!e.target.closest('[data-sl-collection-close]')) { return; }
        if (collection) { collection.hidden = true; }
        try { window.localStorage.setItem(DISMISS_KEY, '1'); } catch (err) {}
      });

      // Pre-fill both inputs with any persisted location (the label if we have
      // one, else the postcode) so the value shows when the entry is reopened.
      var savedState = loadState();
      var savedValue = savedState.label || savedState.postcode;
      if (savedValue) {
        if (searchInput) { searchInput.value = savedValue; }
        if (inlineInput) { inlineInput.value = savedValue; }
      } else {
        /* No choice made on this device yet. If the customer is logged in and has
           an address on their account, seed the postcode from it so they do not
           have to retype something we already know. A store chosen by hand is
           saved to localStorage and takes this branch out of play, so this never
           overrides an explicit choice. The lookup itself is queued for the
           geocoder rather than run now: loading the Maps API on every product
           page just in case would be a real cost for something the reader may
           never open. */
        var acctPostcode = drawer.getAttribute('data-customer-postcode');
        if (acctPostcode) {
          var acctSuburb = drawer.getAttribute('data-customer-suburb') || '';
          var seedLabel = acctSuburb ? acctSuburb + ' ' + acctPostcode : acctPostcode;
          if (searchInput) { searchInput.value = seedLabel; }
          if (inlineInput) { inlineInput.value = seedLabel; }
          pendingAccountPostcode = seedLabel;
          /* Load Maps now rather than waiting for the drawer, so the store is
             already chosen when the card first paints. Resolving a postcode to a
             store needs the geocoder and there is no cheaper route: the transit
             endpoint answers with the DISPATCH outlet, which is a warehouse for
             most metro postcodes (Sydney resolves to a Victorian warehouse), so
             it cannot stand in for "nearest store".

             The cost is contained: this only runs for a signed-in customer who
             has an address on their account AND has not chosen a store on this
             device. Everyone else still loads Maps lazily on drawer open. */
          loadMaps();
        }
      }

      reflectMyStoreButtons();
      renderInlineState();
      /* Drawer collection rows are product-level, not selection-level, so they are
         filled once here rather than from renderInlineState - switching store does
         not change any of them. */
      updateStoreCollection();

      /* Mix & Match: the panel is resolved from the SELECTED components, so a
         swap of either side has to re-resolve it. The buy box publishes
         mix-match:change on every change; both component caches are dropped and
         the whole panel repaints through the same path a location change uses,
         so there is no second rendering route to keep in step.

         Debounced because dragging along the carousel fires a change per
         option, and each repaint costs one section render per component. */
      if (isMM) {
        var mmTimer = null;
        document.addEventListener('mix-match:change', function () {
          if (mmTimer) { clearTimeout(mmTimer); }
          mmTimer = setTimeout(function () {
            mmTimer = null;
            componentsPromise = null;
            bundleDisplayPromise = null;
            renderInlineState();
            updateStoreCollection();
          }, 250);
        });
      }
    }

    ready(init);
    document.addEventListener('shopify:section:load', function () { ready(init); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-variants"] && !Shopify.designMode) return;
  try {
    (function () {
    class ProductVariants extends HTMLElement {
      connectedCallback() {
        if (this.__init) return;
        this.__init = true;

        var dataEl = this.querySelector('[data-variant-data]');
        try {
          this.variants = JSON.parse(dataEl ? dataEl.textContent : '[]');
        } catch (e) {
          this.variants = [];
        }
        if (!this.variants.length) return;

        this.optionRows = Array.prototype.slice.call(this.querySelectorAll('[data-option-index]'));
        this.selected = this.optionRows.map(function (row) {
          var chip = row.querySelector('.product-variants__chip--selected');
          return chip ? chip.getAttribute('data-option-value') : null;
        });

        this.addEventListener('click', this.onClick.bind(this));
        this.markAvailability();
      }

      onClick(event) {
        var chip = event.target.closest('.product-variants__chip');
        if (!chip) return;
        var row = chip.closest('[data-option-index]');
        if (!row) return;
        var index = Number(row.getAttribute('data-option-index'));
        this.selected[index] = chip.getAttribute('data-option-value');

        var variant = this.findVariant();
        this.renderSelection();
        if (variant) this.applyVariant(variant);
      }

      findVariant() {
        var selected = this.selected;
        return this.variants.find(function (v) {
          return v.options.every(function (value, i) { return value === selected[i]; });
        }) || null;
      }

      renderSelection() {
        var selected = this.selected;
        this.optionRows.forEach(function (row, i) {
          var label = row.querySelector('[data-selected-label]');
          if (label && selected[i] != null) label.textContent = selected[i];
          row.querySelectorAll('.product-variants__chip').forEach(function (chip) {
            var isSelected = chip.getAttribute('data-option-value') === selected[i];
            chip.classList.toggle('product-variants__chip--selected', isSelected);
            chip.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });
        });
        this.markAvailability();
      }

      /* Strike chips whose value yields no available variant given the OTHER
         selected options (single-option products reduce to per-variant stock). */
      markAvailability() {
        var variants = this.variants;
        var selected = this.selected;
        this.optionRows.forEach(function (row, i) {
          row.querySelectorAll('.product-variants__chip').forEach(function (chip) {
            var value = chip.getAttribute('data-option-value');
            var candidate = selected.slice();
            candidate[i] = value;
            var match = variants.find(function (v) {
              return v.options.every(function (opt, j) { return opt === candidate[j]; });
            });
            chip.classList.toggle('product-variants__chip--unavailable', !match || !match.available);
          });
        });
      }

      applyVariant(variant) {
        var scope = this.closest('.product') || document;

        scope.querySelectorAll('form.product__form input[name="id"]').forEach(function (input) {
          input.value = variant.id;
        });

        /* Plain price rows only: swap the active amount(s), leave compare/sale
           internals alone (gift cards and other variant products render the
           simple single-amount state). */
        var priceEl = scope.querySelector('[data-price]');
        if (priceEl) {
          priceEl.querySelectorAll('.price__amount:not(.price__amount--compare)').forEach(function (amount) {
            amount.textContent = variant.price;
          });
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        this.dispatchEvent(new CustomEvent('variant:change', {
          bubbles: true,
          detail: { variantId: variant.id, price: variant.price, available: variant.available }
        }));
      }
    }

    if (!customElements.get('product-variants')) {
      customElements.define('product-variants', ProductVariants);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
